/* ===== Vagt: dedupliker identiske /cart/add-kald (Xtra stabler handlers) ===== */
(function(){
  var orig = window.fetch, pending = new Map();
  function bodyKey(b){
    if(!b) return '';
    if(typeof b === 'string') return b;
    if(b instanceof URLSearchParams) return b.toString();
    if(b instanceof FormData){ var a=[]; b.forEach(function(v,k){ a.push(k+'='+v); }); return a.join('&'); }
    return '';
  }
  function fire(name){ try{ document.dispatchEvent(new CustomEvent(name)); }catch(_){} }
  window.fetch = function(input, init){
    try{
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if(method === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url)){
        var key = url + '|' + bodyKey(init && init.body);
        var now = Date.now(), hit = pending.get(key);
        if(hit && now - hit.t < 1500){ return hit.p.then(function(r){ return r.clone(); }); }
        fire('pb:cartadd:start');
        var p = orig.apply(this, arguments);
        pending.set(key, {t: now, p: p});
        p.then(function(){ setTimeout(function(){ pending.delete(key); }, 1500); fire('pb:cartadd:end'); },
               function(){ pending.delete(key); fire('pb:cartadd:end'); });
        return p.then(function(r){ return r.clone(); });
      }
    }catch(_){}
    return orig.apply(this, arguments);
  };
})();

/* ===== Optimistisk kurv: åbn draweren straks ved klik ===== */
(function(){
  var html=document.documentElement, userClosed=false, timers=[], lastUser=0, lastOpenIntent=0,
      wasOpen=html.classList.contains('m6pn-open');
  /* justér selektoren hvis jeres kurv-ikon hedder noget andet */
  var OPEN_SEL='a[href$="/cart"], a[href*="/cart?"], a[href="#cart"], [data-cart-toggle], #header a.cart, #top a.cart';
  ['pointerdown','keydown'].forEach(function(ev){
    document.addEventListener(ev,function(e){
      lastUser=Date.now();
      if(e.target.closest && e.target.closest(OPEN_SEL)) lastOpenIntent=Date.now();
    },true);
  });
  function aside(){ return document.querySelector('aside#cart'); }
  function clearTimers(){ timers.forEach(clearTimeout); timers=[]; }
  function ensureOpen(){
    if(userClosed) return;
    var a=aside(); if(!a) return;
    if(!html.classList.contains('has-panels')) html.classList.add('has-panels');
    if(!html.classList.contains('m6pn-open'))  html.classList.add('m6pn-open');
    if(!a.classList.contains('toggle'))        a.classList.add('toggle');
    if(a.getAttribute('aria-hidden')!=='false') a.setAttribute('aria-hidden','false');
  }
  function forceClose(){
    var a=aside();
    html.classList.remove('m6pn-open');
    if(a){ a.classList.remove('toggle'); a.setAttribute('aria-hidden','true'); }
  }
  new MutationObserver(function(){
    var open=html.classList.contains('m6pn-open');
    if(wasOpen && !open && Date.now()-lastUser<1200){
      userClosed=true; clearTimers();                        /* bruger lukkede (kryds ELLER klik udenfor) */
    }
    if(!wasOpen && open && userClosed){
      if(Date.now()-lastOpenIntent<1200){ userClosed=false; } /* klik på kurv-ikonet → ok */
      else {
        wasOpen=false;                                       /* temaet genåbnede → luk igen */
        forceClose();
        return;
      }
    }
    wasOpen=open;
  }).observe(html,{attributes:true,attributeFilter:['class']});
  document.addEventListener('pb:cartadd:start',function(){
    userClosed=false; clearTimers();                         /* nyt add-klik → må gerne åbne */
    ensureOpen();
    var a=aside(); if(a) a.classList.add('pb-loading');
  });
  document.addEventListener('pb:cartadd:end',function(){
    var a=aside(); if(a) a.classList.remove('pb-loading');
    clearTimers();
    [0,80,250,600,900].forEach(function(ms){ timers.push(setTimeout(ensureOpen,ms)); });
  });
})();


/* ===== Optimistisk varelinje i draweren ===== */
(function(){
  var last=null;
  document.addEventListener('pointerdown',function(e){
    var b=e.target.closest('button,[type="submit"],a.overlay-buy_button');
    if(!b) return;
    var root=b.closest('li, article, .product, #content') || b.closest('form[action*="/cart/add"]') || document;
    var t=root.querySelector('h1, h2 a, h2, h3 a, h3, .product-title');
    var img=root.querySelector('img');
    last={ title: t ? t.textContent.trim() : '', src: img ? (img.currentSrc||img.src) : '' };
  },true);
  function skel(){
    var a=document.querySelector('aside#cart'); if(!a) return;
    a.querySelectorAll('.pb-skel').forEach(function(n){ n.remove(); });
    var ul=a.querySelector('ul.l4ca.compact:not(.in-panel)');
    var el=document.createElement(ul?'li':'div'); el.className='pb-skel';
    el.innerHTML='<span class="pb-skel-img">'+(last&&last.src?'<img src="'+last.src+'" alt="">':'')+'</span>'
               + '<span class="pb-skel-txt"><b>'+(last&&last.title?last.title:'')+'</b><i></i></span>';
    if(ul) ul.insertAdjacentElement('afterbegin',el);
    else { var f=a.querySelector('form')||a; f.insertAdjacentElement('afterbegin',el); }
  }
  document.addEventListener('pb:cartadd:start',skel);
  document.addEventListener('pb:cartadd:end',function(){
    setTimeout(function(){ document.querySelectorAll('aside#cart .pb-skel').forEach(function(n){ n.remove(); }); },4000);
  });
})();

/* ===== Upsell: vis vores egen kopi, temaets boks holdes skjult ===== */
(function(){
  var cart=document.querySelector('aside#cart'); if(!cart) return;
  var KEY='pb_upsell_v2', cache={cards:'',title:''}, running=false, box=null, applied='', lastX=0;
  try{ cache=JSON.parse(sessionStorage.getItem(KEY))||cache; }catch(_){}
  function src(){ return cart.querySelector('.cart-upsell.product-recommendations'); }
  function clone(){ return cart.querySelector('.cart-upsell.pb-clone'); }
  function ensureClone(){
    if(!cache.cards) return;
    var t=cart.querySelector('ul.l4tt'), list=cart.querySelector('ul.l4ca.compact:not(.in-panel)');
    if(!t && !(list && list.querySelector('li'))) return;                 /* tom kurv */
    if(!box){                                                              /* byg kun én gang – samme node genbruges */
      box=document.createElement('div'); box.className='cart-upsell pb-clone';
      box.innerHTML='<h3>'+cache.title+'</h3><ul class="l4ca compact in-panel base-font form-group">'+cache.cards+'</ul>';
      applied=cache.cards;
      box.querySelector('ul').addEventListener('scroll',function(){ lastX=this.scrollLeft; },{passive:true});   /* husk slider-position */
    }
    var back=!box.isConnected;                                             /* genindsættes efter kurvændring? */
    if(t){ if(box.nextElementSibling!==t) t.insertAdjacentElement('beforebegin',box); }
    else if(!box.isConnected){ list.insertAdjacentElement('afterend',box); }
    if(back){
      box.querySelector('ul').scrollLeft=lastX;                            /* tilbage på samme kort */
      setTimeout(function(){ window.dispatchEvent(new Event('resize')); }, 0);   /* temaet måler bunden igen */
    }
  }
  function tick(){
    if(running) return; running=true;
    try{
      var s=src();
      if(s){
        if(!s.classList.contains('pb-upsell-src')) s.classList.add('pb-upsell-src');
        var ul=s.querySelector('ul.l4ca.in-panel'), h3=s.querySelector('h3');
        if(!s.classList.contains('hidden') && ul && ul.querySelectorAll(':scope > li').length){
          var fresh=ul.innerHTML;
          if(fresh!==cache.cards){                                         /* nye kort fra temaet → husk dem */
            cache={cards:fresh, title:h3?h3.textContent.trim():cache.title};
            try{ sessionStorage.setItem(KEY,JSON.stringify(cache)); }catch(_){}
          }
        }
      }
      ensureClone();
      var c=clone(), cu=c&&c.querySelector('ul.l4ca.in-panel');
      if(cu && applied!==cache.cards){   /* byt KUN mens skuffen er lukket, og kun én gang pr. nye kort */
        cu.innerHTML=cache.cards; cu.scrollLeft=0; lastX=0; applied=cache.cards;
      }
    }finally{ running=false; }
  }
  var obs=new MutationObserver(tick);
  obs.observe(cart,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});
  tick();
})();

/* ===== Upsell-kort: læg i kurven selv (aldrig submit af Kasse-formularen) ===== */
(function(){
  var cart=document.querySelector('aside#cart'); if(!cart) return;
  var SEL='aside#cart .cart-upsell li.product-card button.overlay-buy_button', downBtn=null, downT=0;
  document.addEventListener('pointerdown',function(e){ downBtn=e.target.closest(SEL); downT=Date.now(); },true);
  function rerender(){
    var q=cart.querySelector('.input-amount input[type="number"]');
    if(!q){ location.reload(); return; }
    cart.classList.add('pb-loading');
    var obs=new MutationObserver(function(){ cart.classList.remove('pb-loading'); obs.disconnect(); });
    obs.observe(cart,{childList:true,subtree:true});
    setTimeout(function(){ cart.classList.remove('pb-loading'); obs.disconnect(); },4000);
    q.dispatchEvent(new Event('change',{bubbles:true}));
  }
  document.addEventListener('click',function(e){
    var btn=e.target.closest(SEL) || (downBtn && Date.now()-downT<800 && e.target.closest('aside#cart .cart-upsell') ? downBtn : null);
    if(!btn) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var li=btn.closest('li'), id=li&&li.querySelector('input[name="id"]'); if(!id) return;
    if(btn.dataset.pbBusy) return; btn.dataset.pbBusy='1';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded','Accept':'application/json'},
      body:'id='+encodeURIComponent(id.value)+'&quantity=1'})
      .then(function(r){ if(!r.ok) throw 0; return r.json(); })
      .then(rerender)
      .catch(function(){ cart.classList.remove('pb-loading'); })
      .then(function(){ delete btn.dataset.pbBusy; });
  },true);
})();

/* ===== Antal-pile: saml klik, hold ønsket antal, send ét /cart/change ad gangen ===== */
(function(){
  var want={}, sent={}, timer=null, busy=false, busyT=null;
  function inputFor(line){ return document.querySelector('.input-amount input[data-line="'+line+'"]'); }
  function paint(inp,v){
    inp.value=v;
    var wrap=inp.closest('.input-amount'), i=wrap.querySelector('a.incr'), d=wrap.querySelector('a.decr');
    var min=parseInt(inp.min)||1, max=parseInt(inp.max)||9999;
    if(i) i.classList.toggle('disabled', v>=max);
    if(d) d.classList.toggle('disabled', v<=min);
  }
  function flush(){
    if(busy) return;
    for(var line in want){
      var inp=inputFor(line);
      if(!inp){ delete want[line]; delete sent[line]; continue; }
      if(parseInt(inp.value)===want[line] && sent[line]===want[line]){ delete want[line]; delete sent[line]; continue; }
      if(sent[line]===want[line]){ /* sendt, serveren gav noget andet (fx lager) → serveren vinder */
        delete want[line]; delete sent[line]; continue;
      }
      paint(inp,want[line]);
      sent[line]=want[line]; busy=true;
      clearTimeout(busyT); busyT=setTimeout(function(){ busy=false; flush(); },4000);
      inp.dispatchEvent(new Event('change',{bubbles:true}));
      return; /* én ad gangen */
    }
  }
  document.addEventListener('click',function(e){
    var btn=e.target.closest('.input-amount a.incr, .input-amount a.decr'); if(!btn) return;
    var inp=btn.closest('.input-amount').querySelector('input[type="number"]'); if(!inp) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var line=inp.dataset.line||inp.id;
    var min=parseInt(inp.min)||1, max=parseInt(inp.max)||9999, step=parseInt(inp.step)||1;
    var cur=(line in want)?want[line]:(parseInt(inp.value)||min);
    var v=btn.classList.contains('incr')?cur+step:cur-step;
    v=Math.max(min,Math.min(max,v));
    if(v===cur) return;
    want[line]=v; paint(inp,v);
    clearTimeout(timer); timer=setTimeout(flush,450);
  },true);
  var cart=document.querySelector('aside#cart');
  if(cart) new MutationObserver(function(){
    /* re-render = forrige change er færdig; vis ønsket antal i det nye felt og send igen hvis nødvendigt */
    for(var line in want){ var inp=inputFor(line); if(inp && parseInt(inp.value)!==want[line]) paint(inp,want[line]); }
    if(busy){ busy=false; clearTimeout(busyT); clearTimeout(timer); timer=setTimeout(flush,150); }
  }).observe(cart,{childList:true,subtree:true});
})();

/* ===== Optimistisk fjern: skjul straks, kø ét /cart/change ad gangen ===== */
(function(){
  var cart=document.querySelector('aside#cart'); if(!cart) return;
  var SEL='a[href*="quantity=0"], a.remove, [data-remove], .l4ca-remove';
  var queue=[], current=null, busyT=null;
  function titleOf(li){ var h=li.querySelector('h2 a, h2, h3 a, h3'); return h?h.textContent.trim():''; }
  function items(){ return Array.from(cart.querySelectorAll('ul.l4ca.compact:not(.in-panel) > li')); }
  function markPending(){                                    /* re-render fjerner klassen → sæt den på igen */
    items().forEach(function(li){
      var t=titleOf(li);
      if(t===current || queue.indexOf(t)!==-1) li.classList.add('pb-removing');
    });
  }
  function stop(){ current=null; clearTimeout(busyT); cart.classList.remove('pb-loading'); }
  function fireRemove(li){
    var a=li.querySelector(SEL); if(!a) return false;
    current=titleOf(li);
    cart.classList.add('pb-loading');
    clearTimeout(busyT);
    busyT=setTimeout(function(){                             /* fejl/timeout: vis varen igen, den er der stadig */
      var t=current;
      stop();
      items().forEach(function(l){ if(titleOf(l)===t) l.classList.remove('pb-removing'); });
      next();
    },4000);
    li.classList.add('pb-removing');
    a.dispatchEvent(new MouseEvent('click',{bubbles:true,cancelable:true}));   /* temaets egen handler */
    return true;
  }
  function next(){
    if(current) return;
    while(queue.length){
      var title=queue.shift();
      var li=items().find(function(l){ return titleOf(l)===title; });
      if(li && fireRemove(li)) return;
    }
  }
  document.addEventListener('click',function(e){
    var a=e.target.closest('aside#cart '+SEL.split(', ').join(', aside#cart ')); if(!a) return;
    if(e.isTrusted===false) return;            /* vores eget videresendte klik → lad temaet tage det */
    var li=a.closest('li'); if(!li) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var t=titleOf(li);
    li.classList.add('pb-removing');
    if(current){ if(queue.indexOf(t)===-1 && t!==current) queue.push(t); return; }
    fireRemove(li);
  },true);
  new MutationObserver(function(){
    markPending();
    if(current && !items().some(function(l){ return titleOf(l)===current; })){
      stop(); next();                                        /* aktuel titel væk = change færdig */
    }
  }).observe(cart,{childList:true,subtree:true});
})();

/*global document, window, yall, setTimeout, Swiper, createElementWithClass, createRatingsHtmlElement, Cookies, semanticTabs, Image, Shopify, Event, getComputedStyle, CustomEvent, enquire, IntersectionObserver, MutationObserver */
/*//jshint esversion: 6 */
if (typeof html_tag == undefined) { let html_tag = document.documentElement } else { html_tag = document.documentElement }
if (typeof root_styles == undefined) { let root_styles = document.querySelector(':root') } else { root_styles = document.querySelector(':root') }
if (typeof top_id == undefined) { let top_id = document.querySelector('.shopify-section-header') } else { top_id = document.querySelector('.shopify-section-header') }
let nav_top_id = document.querySelector('#nav-top');
if (typeof header_outer == undefined) { let header_outer = document.querySelector('#header-outer') } else { header_outer = document.querySelector('#header-outer') }
let header_id = header_outer.querySelector('#header');
if (typeof header_inner == undefined) { let header_inner = document.querySelector('#header-inner') } else { header_inner = document.querySelector('#header-inner') }
let logo_id = document.querySelector('#logo');
let logo_img = logo_id.querySelector('img');
let search_id = document.querySelector('#search');
let nav_outer = document.querySelector('#nav-outer');
let nav_bar_id = document.querySelector('#nav-bar');
let nav_id = document.querySelector('#nav');
if (typeof content_id == undefined) { let content_id = document.getElementById('content') } else { content_id = document.getElementById('content') }


let html_width = html_tag.getBoundingClientRect().width;
let nav_main = nav_bar_id ?? nav_id;

let global_dir;
if (html_tag.getAttribute('dir') === 'rtl') {
	global_dir = ['rtl', false];
} else {
	global_dir = ['ltr', true];
}

function isTouchDevice() {
	'use strict';
	return window.matchMedia("(pointer: coarse)").matches;
}

const isMobile = window.mobileCheck() || isTouchDevice();
  
// for (let i = 0; i < img_lazy.length; i = i + 1) {
// 	img_lazy[i].classList.add('lazy');
// 	if (!img_lazy[i].hasAttribute('src')) {
// 		img_lazy[i].setAttribute('src', img_lazy[i].getAttribute('data-src'));
// 	}
// }

var listCollectionSliderEvt = new CustomEvent("listCollectionSlider"),
	semanticSelectEvt = new CustomEvent("semanticSelect"),
	productcardVariantsEvt = new CustomEvent("productcardVariants"),
  quickShopEvt = new CustomEvent('quickShop'),
  ajaxCartEvt = new CustomEvent('ajaxCart'),
	announcementSliderEvt = new CustomEvent("announcementSlider"),
	moduleFeaturedSliderEvt = new CustomEvent("moduleFeaturedSlider"),
	listProductSliderEvt = new CustomEvent("listProductSlider"),
	listUspSliderEvt = new CustomEvent("listUspSlider"),
	listTestimonialsSliderEvt = new CustomEvent("listTestimonialsSlider"),
	listStaticSliderEvt = new CustomEvent("listStaticSlider"),
	searchClassesEvt = new CustomEvent("searchClasses"),
	createColsEvt = new CustomEvent("createCols"),
	moduleTabsEvt = new CustomEvent("moduleTabs"),
	formZindexEvt = new CustomEvent("formZindex"),
	ratingsEvt = new CustomEvent("ratings"),
	inputPaddingEvt = new CustomEvent("inputPadding"),
	topEvt = new CustomEvent("top"),
	backgroundEvt = new CustomEvent("background"),
  lazyVideoEvt = new CustomEvent("lazyVideo"),
  mediaFlexibleEvt = new CustomEvent("mediaFlexbile"),
	setCustomDropHeightEvt = new CustomEvent("setCustomDropHeight");

  function isHasSelectorSupported() {
    const testElement = document.createElement('div');
    try {
      testElement.querySelector(':has(*)');
      return true;
    } catch (error) {
      return false;
    }
  }
  function getSiblings(el) {
    'use strict';
    return Array.from(el.parentNode.children).filter(function (sibling) {
      return sibling !== el;
    });
  }
  
  function append_url(el, content, className, href, access) {
    'use strict';
    const link = createElementWithClass('a', className);
    link.href = href || './';
    if (access === true) {
      link.setAttribute('tabindex', -1);
      link.setAttribute('aria-hidden', true);
      link.setAttribute('focusable', false);
    }
    link.innerHTML += content;
    if (el) {
      el.appendChild(link);
    }
  }
  
  function wrap(el, wrapper, className) {
    'use strict';
    el.parentNode.insertBefore(wrapper, el);
    if (className) {
      wrapper.classList.add(className);
    }
    wrapper.appendChild(el);
  }
  
  function new_css(id, href, media) {
    "use strict";
    if (!document.getElementById(id)) {
      const a = document.createElement('link');
      if (media === undefined) {
        media = 'screen';
      }
      a.setAttribute('id', id);
      a.setAttribute('rel', 'stylesheet');
      a.setAttribute('href', href);
      a.setAttribute('media', media);
      a.setAttribute('id', id);
  
      const b = document.querySelectorAll('link[id]');
      if (b.length) {
        Array.from(b).forEach(function (el) {
          el.after(a);
        });
      } else {
        document.head.appendChild(a);
      }
    }
  }

  function customDropHeight() {
    'use strict';
    if (nav_main) {
      const HH_req = ['.m6fr.wide-transparent', '.m6fr.size-xl', '.m6fr article.size-xl'];
      const hasHH = HH_req.some(selector => document.querySelector(selector));
  
      if (hasHH) {
        requestAnimationFrame(function () {
          if (header_outer && header_inner) {
            const headerHeight = header_outer.getBoundingClientRect().height + 'px';
            root_styles.style.setProperty('--header_height_static', headerHeight);
          }
          if (nav_top_id) {
            const nav_top_idHeight = nav_top_id.getBoundingClientRect().height + 'px';
            root_styles.style.setProperty('--nav_top_h', nav_top_idHeight);
          }
        });
      }
    }
  }

  let stickyOffsetCalculated = false;
  function stickyOffset() {
    if (!stickyOffsetCalculated && nav_main) {
      const SO_req = ['.m6pr', '[id^="section-"]', '.f8ps', '.f8sr', '.m6cl', '.m6ac'];
      if (header_outer && header_inner) {
        let headerHeight;

        if (SO_req.some(selector => document.querySelector(selector))) {
          const setStickyOffset = () => {
            const height = header_outer.getBoundingClientRect().height + 'px';
            root_styles.style.setProperty('--sticky_offset', height);
          };

          if (header_inner.classList.contains('sticky-nav')) {
            html_tag.classList.add('has-sticky-nav');
            enquire.register('screen and (max-width: 1000px)', function () {
              setStickyOffset();
            }).register('screen and (min-width: 1001px)', function () {
              const nav_mainHeight = nav_main.getBoundingClientRect().height + 'px';
              root_styles.style.setProperty('--sticky_offset', nav_mainHeight);
            });
          } else {
            setStickyOffset();
          }
        }
      }
      stickyOffsetCalculated = true;
    }
  }

  if (!isMobile) {
    document.addEventListener('mouseover', stickyOffset);
  }
  document.addEventListener('keyup', stickyOffset);
  document.addEventListener('touchstart', stickyOffset);
  document.addEventListener('scroll', stickyOffset);
  window.addEventListener('resize', () => {
    stickyOffsetCalculated = false;
    stickyOffset();
  });


  setTimeout(function () {
    'use strict';
    customDropHeight();
  }, 100);
  window.addEventListener('resize', function () {
    'use strict';
    customDropHeight();
    if (header_outer && header_inner) {
      requestAnimationFrame(function () {
        //setTimeout(function () {
        //const header_outerHeight = header_outer.clientHeight + 'px';
        const header_outerHeight = header_outer.getBoundingClientRect().height + 'px';
        root_styles.style.setProperty('--header_height_static', header_outerHeight);
        //}, 500);
      });
    }
  });
  window.addEventListener("setCustomDropHeight", function(evt) {
    customDropHeight();
  });

// delay scrollbar width
let scrollbarWidthCalculated = false;

function getScrollbarWidth() {
    'use strict';

    if (!scrollbarWidthCalculated) {
        root_styles.style.setProperty('--scrollbar_width', window.innerWidth - html_tag.getBoundingClientRect().width + 'px');
        scrollbarWidthCalculated = true;
    }
}

// onload
const SB_req = [".m6bx.wide", ".m6fr.wide", ".l4ft.fullwidth", ".l4cl.fullwidth", ".shopify-section-breadcrumbs"];
if (SB_req.some(selector => document.querySelector(selector))) {
    getScrollbarWidth();

    /*if (!isMobile) {
        document.addEventListener('mouseover', getScrollbarWidth);
    }
    document.addEventListener('keyup', getScrollbarWidth);
    document.addEventListener('touchstart', getScrollbarWidth);
    document.addEventListener('scroll', getScrollbarWidth);*/
}

  
  if (logo_img) {
    if (logo_img.complete) {
      customDropHeight();
    } else {
      logo_img.addEventListener('load', customDropHeight);
    }
  } else {
    customDropHeight();
  }
  
  if (header_inner) {
    if (header_inner.classList.contains('mobile-visible-search')) {
      html_tag.classList.add('has-mobile-visible-search');
    }
    if (header_inner.classList.contains('t1nn')) {
      html_tag.classList.add('t1nn');
    }
  }
  
  if (content_id && header_inner) {
    const ffa = content_id.children[0];
    let ffc;
    let ffd = false;
    let ffe = false;
  
  
    if (ffa) {
      ffc = ffa.children[0];
      if (ffa.classList.contains('shopify-section') && header_inner.hasAttribute('data-transparent')) {
        ffd = true;
      }
  
      if (ffc && (ffc.classList.contains('m6bx') || ffc.classList.contains('m6fr')) && ffc.classList.contains('wide')) {
        ffe = true;
        ffc.classList.add('im-tr');
      }
      const announcementBar = document.querySelector('.shopify-section-header ~ [class*="shopify-section-announcement-bar"]');
      if (announcementBar) {
        ffd = false;
      }
      if (ffd && ffe && ffc && ffc.classList.contains('wide-transparent')) {
        top_id.classList.add('transparent');
        html_tag.classList.add('has-first-m6fr-wide');
        if (ffc.classList.contains('m6bx')) {
          html_tag.classList.add('has-first-m6bx-wide');
        }
      } else {
        header_inner.classList.remove('transparent');
      }
    }
  }

function create_slider(el, settings, minSlides) {
    'use strict';
    var sliderElement = el,
        bg = false,
        child;

    const imgOverlays = [];

    if (el.getElementsByClassName('img-overlay').length) {
        Array.from(el.children).forEach(function (child) {
            if (child.classList.contains('img-overlay')) {
                bg = true;
                imgOverlays.push(child);
                child.remove();
            }
        });
    }
    if (el.children.length > 1) {
        if (el.tagName.toLowerCase() === "ul") {
            el.setAttribute('role', 'none');
            Array.from(el.children).forEach(child => {
                child.setAttribute('role', 'none');
                child.classList.add('li');
            });
        }

        const items = sliderElement.children;

        if (!minSlides) {
            minSlides = 1;
        }
        if (items.length > parseFloat(minSlides)) {
            // if pagination class is different from default value (swiper-pagination), creates pagination element with correct class
            var paginationClass;
            paginationClass = (settings && settings.pagination && settings.pagination.el) || ".swiper-pagination";
            paginationClass = paginationClass.replace(/\./g, " ").trim();

            const dots = createElementWithClass('span', paginationClass);
            const prev = createElementWithClass('span', 'swiper-button-prev');
            const next = createElementWithClass('span', 'swiper-button-next');
            sliderElement.classList.add('s4wi');

            prev.classList.add('swiper-button-nav');
            next.classList.add('swiper-button-nav');
            prev.setAttribute('role', 'navigation');
            next.setAttribute('role', 'navigation');

            Array.from(items).forEach(el => wrap(el, document.createElement('div'), 'swiper-slide'));

            sliderElement.innerHTML = '<div class="swiper-outer"><div class="swiper-wrapper">' + sliderElement.innerHTML + '</div></div> <div class="swiper-custom-pagination"></div>';
            const dots_cont = sliderElement.querySelector('.swiper-custom-pagination');

            if (settings && settings.pagination) {
                settings.pagination.el = settings.pagination.el || "." + paginationClass;
                dots_cont.append(prev, dots, createElementWithClass('span', 'swiper-custom-fraction'), next);
            } else {
                dots_cont.append(prev, next);
            }

            const swiperInstance = new Swiper(sliderElement.children[0], settings);

            const paginationBullets = sliderElement.querySelectorAll('.swiper-pagination-bullet');
            paginationBullets.forEach(bullet => bullet.setAttribute('role', 'navigation'));

            return swiperInstance;
            //return new Swiper(sliderElement.children[0], settings);
        }
    }
    if (bg = true) {
        imgOverlays.forEach(function (imgOverlay) {
            el.appendChild(imgOverlay);
        });
    }

    return null;
}

  function randomize(el) {
    'use strict';
    el.setAttribute('data-random', Math.floor(Math.random() * 10000) + 1);
  }
  
  function clone_with_class(el, cl1, cl2) {
    'use strict';
    const cln = el.cloneNode(true);
    cln.classList.add(cl1);
    el.after(cln);
    el.classList.add(cl2);
  }

  function new_js(el) {
    'use strict';
    var tag = document.createElement('script');
    tag.src = el;
    document.body.appendChild(tag);
  }


  function checkIfImageExists(url, callback) {
    'use strict';
    const img = new Image();
  
    img.onload = () => callback(true);
    img.onerror = () => callback(false);
  
    img.src = url;
    if (img.complete) {
      img.onload();
    }
  }

  function assignIndex(elements) {
    'use strict';
    Array.from(elements).forEach((el, index) => {
      el.style.zIndex = elements.length - index;
    });
  }
  
  //Default.utils.start();
  html_tag.classList.add('js');
  
  //Default.utils.email();
  
  //Default.utils.top();

window.addEventListener("top", function (evt) {
	if (logo_id) {
		const logo_text = logo_id.querySelectorAll('span');
		if (logo_id.parentElement.classList.contains('text-center-logo') && !header_inner.classList.contains('hide-btn')) {
			search_id.classList.add('compact');
		}
		if (logo_text.length) {
			header_inner.classList.add('logo-text');
		}
		const imgWithAlt = logo_id.querySelector('img[alt]');

		if (imgWithAlt) {
			const pt = imgWithAlt.parentNode;

			checkIfImageExists(imgWithAlt.getAttribute('src'), exists => {
				if (!exists) {
					const span = document.createElement('span');
					span.innerHTML = imgWithAlt.getAttribute('alt');
					pt.appendChild(span);
					pt.classList.add('broken-img');
				}
			});
		}
	}

	function calcLogoOffset() {
		if (header_id && logo_id && header_inner.classList.contains('text-center-logo')) {
			const header_width = header_id.getBoundingClientRect().width;
			root_styles.style.setProperty('--logo_offset', logo_id.offsetLeft / header_width * 100 + '%');
		}
	}

	if (nav_id?.classList.contains('no-wide')) {
		top_id.classList.add('has-no-wide');
	}

	if (nav_bar_id?.classList.contains('no-wide')) {
		top_id.classList.add('has-no-wide');
	}
    /*if (nav_id?.classList.contains('no-bd')) {
        top_id.classList.add('has-no-bd');
    }
    if (nav_bar_id?.classList.contains('no-bd')) {
        top_id.classList.add('has-no-bd');
    }*/

	var navs = document.querySelectorAll('#nav, #nav-bar');

	function throttle(callback, delay) {
		let timeoutId;
		return function () {
			if (!timeoutId) {
				timeoutId = setTimeout(() => {
					callback();
					timeoutId = null;
				}, delay);
			}
		};
	}

	function checkInv(el, ratio) {
		"use strict";
		const el_rect = el.getBoundingClientRect();
		const el_off = global_dir[1] === false ? window.innerWidth - el_rect.left - el.offsetWidth : el_rect.left;
		if (el_off > window.innerWidth * ratio) {
			el.classList.add('inv');
		} else {
			el.classList.remove('inv');
		}
	}

	function countNavDist(el, em, nav) {
		const nav_id_offset = 0;
		const d = el.dataset.copy;
		const f = nav.querySelector(`.show-all li[data-copy="${d}"]`);

		if (el.classList.contains('temp-hidden')) {
			el.classList.remove('temp-hidden');
			if (f) {
				f.classList.remove('temp-hidden');
			}
		}

		const jf = el.getBoundingClientRect().width;
		const el_off = (global_dir[1] === false) ? nav.getBoundingClientRect().width - el.offsetLeft - el.getBoundingClientRect().width - nav_id_offset : el.offsetLeft - nav_id_offset;
		const el_tr = el.parentElement.querySelectorAll('.temp-hidden:not(.show-all)').length > 0 ? 1.1 : 0;

		if (nav.getBoundingClientRect().width < el_off + el.getBoundingClientRect().width + jf + em * el_tr) {
			el.classList.add('temp-hidden');
			if (f) {
				f.classList.add('temp-hidden');
			}
		} else {
			el.classList.remove('temp-hidden');
			if (f) {
				f.classList.remove('temp-hidden');
			}
		}
	}

	function countNavDistF(el, em, en, nav) {
		enquire.register('screen and (min-width: 1001px)', function () {
			let mdf;
			const mdm = Math.abs(parseFloat(getComputedStyle(el).getPropertyValue('margin-right')));

			if ((nav.classList.contains('text-justify') || nav.classList.contains('have-text-justify')) && !isNaN(mdm)) {
				mdf = mdm;
			} else {
				mdf = 0;
			}
			const replaceTextClass = (originalClass, replacementClass) => {
				if (nav.classList.contains(originalClass)) {
					nav.classList.remove(originalClass);
					nav.classList.add(replacementClass);
				}
			};
			if (!(el.clientWidth > nav.clientWidth + mdf)) {
				//html_tag.classList.remove('has-long-nav');

				replaceTextClass('have-text-center', 'text-center');
				replaceTextClass('have-text-justify', 'text-justify');
				replaceTextClass('have-text-end', 'text-end');
			} else {
				//html_tag.classList.add('has-long-nav');

				replaceTextClass('text-center', 'have-text-center');
				replaceTextClass('text-justify', 'have-text-justify');
				replaceTextClass('text-end', 'have-text-end');

				if (em.length) {
					en = em[0].getBoundingClientRect().width;
				}
				const children = Array.from(el.children);

				const handleResize = () => {
					children.forEach(eo => {
                        countNavDist(eo, en, nav);
					});
				};
				handleResize();
				window.addEventListener('resize', throttle(handleResize, 200));
			}
		});
	}

	if (navs.length) {
		if (nav_outer) {
			top_id.classList.add('has-nav-outer');
		}
		Array.from(navs).forEach(function (nav_main) {
			if (nav_main.closest('#header-inner') !== null) {
				html_tag.classList.add('has-inside-nav');
				// search_id.classList.add('compact');
			} else {
				html_tag.classList.remove('has-inside-nav');
			}

            const nmu = nav_main.querySelector('[data-type]');
            const nms = 0;

            if (nmu !== null) {

                Array.from(nmu.children).forEach(function (el, index) {
                    el.setAttribute('data-copy', nmu.children.length - index);
                });

                const nml = nmu.querySelector('li.show-all');
                if (nml) {
                    const all_submenu = createElementWithClass('ul', 'show-all-submenu');
                    nml.appendChild(all_submenu);

                    const nmt = Array.from(nml.closest('ul').children);
                    const submenu = nml.querySelector('.show-all-submenu');

                    nmt.forEach(el => {
                        const clone_me = el.cloneNode(true);
                        submenu.appendChild(clone_me);
                    });
                    /*Array.from(nml[0].querySelectorAll('.show-all-submenu')[0].querySelectorAll('.sub-static')).forEach(function (el) {
                        el.remove();
                    });*/


                    function logoLoad() {
                        calcLogoOffset();
                        countNavDistF(nmu, nml, nms, nav_main);
                        top_id.classList.add('ready');
                        header_id.classList.add('ready');
                    }
                    if (nav_outer) {
                        calcLogoOffset();
                        //setTimeout(function () {
                        setTimeout(function () {
                            if (logo_img) {
                                if (logo_img.complete) {
                                    logoLoad();
                                } else {
                                    logo_img.addEventListener('load', logoLoad);
                                }
                            } else {
                                //html_tag.classList.add('has-long-nav');
                                countNavDistF(nmu, nml, nms, nav_main);
                                top_id.classList.add('ready');
                                header_id.classList.add('ready');
                            }
                        }, 250);
                        //}, 250);
                    } else {
                        /*setTimeout(function () {
                            countNavDistF(nmu, nml, nms, nav_main);
                            header_outer.classList.add('ready');
                        }, 250);*/

                        setTimeout(function () {
                            countNavDistF(nmu, nml, nms, nav_main);
                            header_outer.classList.add('ready');
                        }, 250);
                    }

                    window.addEventListener('resize', throttle(() => {
                        calcLogoOffset();
                        //html_tag.classList.add('has-long-nav');
                        header_outer.classList.remove('ready');
                        countNavDistF(nmu, nml, nms, nav_main);
                        header_outer.classList.add('ready');
                    }, 200));

                    if (nav_main.closest('#header-inner') !== null && nav_main.closest('#header-inner').classList.contains('sticky-nav')) {
                        function callback(mutationList, observer) {
                            mutationList.forEach(function (mutation) {
                                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                                    var temp_hidden = nav_main.getElementsByClassName('temp-hidden');
                                }
                            });
                        }
                        const observer = new MutationObserver(callback);
                        observer.observe(nav_main, {
                            attributes: true
                        });
                    }
                }

                const nmv = nav_main.getElementsByClassName('sub-static');
                if (nmv.length) {
					function executeCheckInv() {
						if (!checkInvExecuted) {
							Array.from(nmv).forEach(function (el) {
								//if (!el.classList.contains('show-all')) {
								checkInv(el, 0.5);
								//}
							});
						}
					}
					let checkInvExecuted = false;

					document.addEventListener('mouseover', function () {
						if (!checkInvExecuted) {
							executeCheckInv();
							checkInvExecuted = true;
						}
					});

					window.addEventListener('resize', () => {
						checkInvExecuted = false;
						executeCheckInv();
					});
				}
			}
		});
	}

	if (search_id && header_inner) {
		// if (!isHasSelectorSupported()) {
			if (search_id.classList.contains('no-bg') && !search_id.classList.contains('bd-b')) {
				top_id.classList.add('no-bd-m');
			}
			if (search_id.classList.contains('no-bg')) {
				top_id.classList.add('no-bd');
			}
			if (search_id.classList.contains('no-pd-t')) {
				top_id.classList.add('no-pd-t');
			}
		// }
		if (!search_id.classList.contains('compact') && header_inner.classList.contains('hide-btn') && header_inner.classList.contains('text-center-logo')) {
			search_id.classList.add('not-compact');
			if (search_id.classList.contains('not-compact')) {
				enquire.register('screen and (max-width: 1000px)', function () {
					search_id.classList.add('compact');
				}).register('screen and (min-width: 1001px)', function () {
					search_id.classList.remove('compact');
				});
			}
		}
	}

	// If #nav exists, create a #nav-top for mobile menu
	/*if (nav_id && nav_top_id && !nav_id.querySelectorAll('ul.nav-top').length) {
        Array.from(nav_top_id.querySelectorAll('ul[data-type]')).forEach(function (el) {
            var clone_me = el.cloneNode(true);
            clone_me.classList.add('nav-top');
            nav_id.appendChild(clone_me);
        });
    }*/

	// Detect empty URLs
	if (nav_main) {
		Array.from(nav_main.querySelectorAll('a[href="#"]')).forEach(el => {
			const parent = el.parentElement;
			if (parent) {
				parent.classList.add('empty-url');
			}
		});
	}

    var a_accessible = document.getElementsByClassName('link-accessible');
    function accessibleLink(el) {
      if (html_tag.classList.contains('t1ac')) {
          html_tag.classList.remove('t1ac');
          Cookies.set('accessible', 'no');
      } else {
          new_css('accessible-mode-css', window.filepaths['theme_accessible_css']);
          html_tag.classList.add('t1ac');
          Cookies.set('accessible', 'yes');
      }
      if (nav_id || nav_bar_id) {
          var temp_hidden = nav_main.getElementsByClassName('temp-hidden');
          setTimeout(function () {
              Array.from(temp_hidden).forEach(function (el) {
                  el.classList.remove('temp-hidden');
              });
              window.dispatchEvent(new Event('resize'));
          }, 100);
      }
    }
    if (a_accessible.length) {
        Array.from(a_accessible).forEach(function (el) {
            el.parentElement.classList.add('has-link-accessible');
        });
        html_tag.addEventListener('click', function (event) {
            if (event.target.matches('a.link-accessible, a.link-accessible *')) {
                accessibleLink(event.target.closest('a.link-accessible'));
                event.preventDefault();
            }
        });
        html_tag.addEventListener('keyup', function (event) {
            if (event.key === ' ' && event.target.matches('a.link-accessible, a.link-accessible *')) {
                accessibleLink(event.target.closest('a.link-accessible'));
                event.preventDefault();
            }
        });
    }
  if (Cookies.get('accessible') === 'yes') {
    new_css('accessible-mode-css', window.filepaths['theme_accessible_css']);
    html_tag.classList.add('t1ac');
  } else {
    html_tag.classList.remove('t1ac');
    Cookies.remove('accessible');
  }

	// Searchbox
	if (search_id) {
		if (search_id.classList.contains('compact-handle')) {
			html_tag.classList.add('t1sh-mobile', 'search-compact-handle');
		} else {
			html_tag.classList.remove('t1sh-mobile', 'search-compact-handle');
		}
		if (search_id.classList.contains('compact-handle-mobile')) {
			html_tag.classList.add('t1sh-mobile', 'search-compact-handle', 'search-compact-handle-mobile');
		} else {
			html_tag.classList.remove('search-compact-handle-mobile');
		}
		if (search_id.classList.contains('compact')) {
			if (search_id.classList.contains('compact-handle')) {
				html_tag.classList.add('t1sh');
			} else {
				html_tag.classList.remove('t1sh');
			}
			html_tag.classList.add('t1sr');
		} else {
			html_tag.classList.remove('t1sr', 't1sh');
		}
		if (search_id.classList.contains('text-center-sticky')) {
			html_tag.classList.add('search-compact-is-centered');
		} else {
			html_tag.classList.remove('search-compact-is-centered');
		}
	}
});
window.dispatchEvent(topEvt);

var breadcrumb_back = document.querySelectorAll('.breadcrumb-back');
if (breadcrumb_back.length) {
	Array.from(breadcrumb_back).forEach(function (el) {
		if (document.referrer.indexOf(window.location.host) !== -1) {
			el.addEventListener('click', function (e) {
				history.go(-1); return false;
			})
		}
		else { el.remove(); }
	})
}

//Default.utils.forms();
var select_tag = document.getElementsByTagName('select');
window.addEventListener("formZindex", function (evt) {
	// Assign z-indexes to form elements
	// :placeholder-like support for <select> element
	Array.from(select_tag).forEach(el => {
		const parentNode = el.parentNode;
		const closestParagraph = el.closest('p');

		parentNode.classList.add('has-select');
		if (closestParagraph) {
			closestParagraph.classList.add('has-select');
		}

		el.addEventListener('change', () => {
			el.classList.add('changed');
		});
	});

	let handleFormChildrenCalculated = false;
	function handleFormChildren() {
		if(!handleFormChildrenCalculated){
			var formChildren = document.querySelectorAll('form > *, fieldset > *, .no-zindex, .no-zindex > *, .has-select, .f8pr > *, .l4ca.compact.in-panel > *, .l4cl.box > li, .f8pr-bulk > *');
			if (formChildren.length) {
				assignIndex(formChildren);
			}
			handleFormChildrenCalculated = true;
		}
	}
	if (!isMobile) {
		document.addEventListener('mouseover', handleFormChildren);
	}
	document.addEventListener('keyup', handleFormChildren);
	document.addEventListener('touchstart', handleFormChildren);
	document.addEventListener('scroll', handleFormChildren);
	window.addEventListener('resize', handleFormChildren);
});
window.dispatchEvent(formZindexEvt);

/*requestAnimationFrame(function () {
    runPaddingsForInputs();
});*/
function runPaddingsForInputs(element) {
    const prefixSpan = element.querySelector('span:first-child');
    if (prefixSpan) {
        const sibling = prefixSpan.nextElementSibling;
        if (sibling) {
            sibling.style.setProperty('--pdi', prefixSpan.offsetWidth + 'px');
        }
    }
}
requestAnimationFrame(function () {
    Array.from(document.querySelectorAll('[class*="input-"][class*="fix"]')).forEach(runPaddingsForInputs);
});

window.check_limit_event = function() {
	var check_limit = document.querySelectorAll('.check[data-limit]');
	if (check_limit.length) {
		Array.from(check_limit).forEach(function (el) {
			if (!el.classList.contains('check-limit-initialized')) {
				el.classList.add('check-limit-initialized');
				var tag_limit = 'a',
					limit,
					trigger,
					nextAll = false,
					lastDesc;
				if (el.tagName.toLowerCase() === 'ul' || el.tagName.toLowerCase() === 'ol') {
					tag_limit = 'li';
				}
				limit = createElementWithClass(tag_limit, 'limit');
				trigger = el.children[el.dataset.limit - 1];

				if (trigger !== undefined) {
					nextAll = [].filter.call(trigger.parentNode.children, function (htmlElement) {
						return (htmlElement.previousElementSibling === trigger) ? nextAll = true : nextAll;
					});
					nextAll.forEach(function (em) {
						if (!em.classList.contains('hidden')) {
							em.classList.add('hidden-check');
						}
					});
					limit.innerText = '+' + Math.abs(el.querySelectorAll('li:not(.hidden, .tip-cont)').length - el.dataset.limit);
					if (tag_limit = 'li') {
						limit.innerHTML = '<a href="./">' + limit.innerHTML + '</a>';
					}
					el.append(limit);
					lastDesc = el.querySelector('li.hidden');
					if (lastDesc) {
						el.appendChild(lastDesc);
					}
					Array.from(el.querySelectorAll('a.limit, .limit a')).forEach(function (em) {
						em.addEventListener('click', function (e) {
							el.classList.add('limit-clicked');
							e.preventDefault();
						});
					});
				}
			}
		});
	}
};
check_limit_event();

//Default.utils.footer();
// Change the position of background element (just for security)
window.addEventListener("background", function(evt) {
	// Change the position of background element (just for security)
	if (document.querySelector('#background.done')) {
		document.querySelector('#background.done').remove();
	}
	const background_id = document.getElementById('background');
	if (background_id && !background_id.classList.contains('static') && (background_id.parentNode.id === 'content' || background_id.parentNode.classList.contains('shopify-section'))) {
		document.getElementById('root').appendChild(background_id);
		background_id.classList.add('done');
	}
});
window.dispatchEvent(backgroundEvt);

//Default.utils.tabs();
// Create tabs
window.addEventListener("moduleTabs", function(evt) {
	var tabs_holder = document.querySelectorAll('#content, .m6pn');
	if (tabs_holder.length) {
		Array.from(tabs_holder).forEach(function (el) {
			const module_tabs = el.getElementsByClassName('m6tb');
			if (module_tabs.length) {
				Array.from(module_tabs).forEach(function (el) {
					if (typeof semanticTabs === 'function' && !el.classList.contains('tabs-initialized')) {
						semanticTabs(el);
					}
					el.classList.add('tabs-initialized');
				});
			}
		});
	}
});
window.dispatchEvent(moduleTabsEvt);

//Default.utils.swipers();
var list_testimonials, list_static, popup_a, list_collection_slider;
window.addEventListener("moduleFeaturedSlider", function(event) {
	const module_featured = document.querySelectorAll('.m6fr:not(.s4wi)');
	if (module_featured.length) {
		Array.from(module_featured).forEach(function (el) {
			var pagination_type = 'bullets',
				autoplay_int = false,
				total_sl = el.children.length,
				featuredSlider;
			el.querySelectorAll('figure').forEach(function (em) {
				if (em.getElementsByTagName('picture').length > 1) {
					em.classList.add('has-pics');
				}
			});
			if (el.classList.contains('slider-fraction')) {
				pagination_type = 'fraction';
			}
			if (el.getAttribute('data-autoplay')) {
				autoplay_int = {
					delay: parseFloat(el.getAttribute('data-autoplay')),
					pauseOnMouseEnter: true
				};
			}
			randomize(el);
			const randomId = el.getAttribute('data-random');
			featuredSlider = create_slider(el, {
				direction: 'horizontal',
				loop: true,
				autoHeight: true,
				resizeObserver: true,
				autoplay: autoplay_int,
				threshold: 50,
				pagination: {
					el: '.swiper-pagination-' + randomId,
					clickable: true,
					type: pagination_type,
					renderBullet: function (index, className) {
						return '<span class="' + className + '">' + (index + 1) + "<span class='prg'></span></span>";
					},
					renderFraction: function (currentClass, totalClass) {
						return '<span class="' + currentClass + '"></span>' +
							' <span class="slash">/</span> ' +
							'<span class="' + totalClass + '"></span>';
					}
				},
				navigation: {
					nextEl: '[data-random="' + randomId + '"] .swiper-button-next',
					prevEl: '[data-random="' + randomId + '"] .swiper-button-prev'
				},
				on: {
					afterInit: function (swiper) {
						updateSwiper(swiper);
					},
					slideChangeTransitionStart: function (swiper) {
						updateSwiper(swiper);
            Array.from(el.querySelectorAll('.swiper-slide > article.aside')).forEach(function (em) {
              em.parentNode.classList.add('has-aside');
            });
            var active_content = swiper.el.querySelectorAll('.swiper-slide[data-swiper-slide-index="' + swiper.realIndex + '"] > article')[0];
            if (typeof active_content !== 'undefined') {
              el.setAttribute('data-active-content', active_content.getAttribute('class'));
            }
            if (swiper.realIndex > 0) {
              el.classList.add('changed');
            } else {
              el.classList.remove('changed');
            }
            if (swiper.realIndex + 1 === total_sl) {
              el.classList.add('last-slide-active');
            } else {
              el.classList.remove('last-slide-active');
            }
					},
					resize: function (swiper) {
						if (typeof Shopify !== 'undefined' && Shopify.designMode) {
							Array.from(featuredSlider.slides).forEach(function () {
								featuredSlider.slideNext(0);
							});
						}
						setTimeout(function () {
							featuredSlider.updateAutoHeight();
						}, 500);

					}
				}

			});
			function updateSwiper(swiper) {
				Array.from(el.querySelectorAll('.swiper-slide > article.aside')).forEach(em => {
					em.parentNode.classList.add('has-aside');
				});
				const active_content = swiper.el.querySelector('.swiper-slide[data-swiper-slide-index="' + swiper.realIndex + '"] > article');
				if (typeof active_content !== 'undefined') {
					el.setAttribute('data-active-content', active_content.getAttribute('data-color-palette'));
				}
				if (swiper.realIndex > 0) {
					el.classList.add('changed');
				} else {
					el.classList.remove('changed');
				}
				if (swiper.realIndex + 1 === total_sl) {
					el.classList.add('last-slide-active');
				} else {
					el.classList.remove('last-slide-active');
				}
			}
			if (featuredSlider !== null) {
				if (el.getAttribute('data-autoplay') && !el.classList.contains('no-controls')) {
					append_url(el, 'Play/Pause', 'play-pause');
					el.querySelector('.play-pause').addEventListener('click', function (e) {
						if (el.classList.contains('paused')) {
							el.classList.remove('paused');
							featuredSlider.autoplay.start();
						} else {
							el.classList.add('paused');
							featuredSlider.autoplay.stop();
						}
						e.preventDefault();
					});
					el.addEventListener('mouseleave', function () {
						if (!el.classList.contains('paused')) {
							featuredSlider.autoplay.start();
						}
					});
				}
				window.addEventListener('resize', function (event) {
					html_tag.classList.add('resized');
				}, true);
				setTimeout(function () {
					featuredSlider.updateAutoHeight();
				}, 500);
			}
			if (el.classList.contains('s4wi')) {
				setTimeout(function () {
					if (typeof updateSlidersEvt != 'undefined') {
						window.dispatchEvent(updateSlidersEvt);
					}
				}, 300);
			}
		});
	}
});
window.dispatchEvent(moduleFeaturedSliderEvt);

window.addEventListener("announcementSlider", function(event) {
	top_bar = document.querySelector('.shopify-section-announcement-bar:not(.s4wi)');
	var top_bar_children = document.querySelectorAll('.shopify-section-announcement-bar:not(.s4wi) > *:not(.close, .overlay-close)');
	if (top_bar && top_bar_children.length > 1 && !top_bar.classList.contains('m6kn')) {
		Array.from(top_bar.querySelectorAll('.close, .overlay-close')).forEach(function (el) {
			el.remove();
		});
		let autoplay_top_int = false;

		const dataAutoplay = top_bar.getAttribute('data-autoplay');
		if (dataAutoplay) {
			autoplay_top_int = {
				delay: parseFloat(dataAutoplay),
				pauseOnMouseEnter: true,
				disableOnInteraction: false
			};
		}
		if (top_bar.querySelector('.no-nav')) {
			top_bar.classList.add('no-nav');
		}
		randomize(top_bar);
		const randomId = top_bar.getAttribute('data-random');
		create_slider(top_bar, {
			direction: 'horizontal',
			loop: true,
			autoHeight: true,
			spaceBetween: window.innerWidth * 0.5,
			autoplay: autoplay_top_int,
			pagination: false,
			navigation: {
				nextEl: '[data-random="' + randomId + '"] .swiper-button-next',
				prevEl: '[data-random="' + randomId + '"] .swiper-button-prev'
			}
		});
	}
});
window.dispatchEvent(announcementSliderEvt);

list_panel_slider = document.getElementsByClassName('l4ps');
if (list_panel_slider.length) {
	Array.from(list_panel_slider).forEach(function (el) {
		var pagination_type = 'bullets',
			autoplay_int = false,
			total_sl = el.children.length;
		if (el.classList.contains('slider-fraction')) {
			pagination_type = 'fraction';
		}
		if (el.getAttribute('data-autoplay')) {
			autoplay_int = {
				delay: parseFloat(el.getAttribute('data-autoplay')),
				pauseOnMouseEnter: true,
				disableOnInteraction: false
			};
		}
		randomize(el);
		const randomId = el.getAttribute('data-random');
		create_slider(el, {
			direction: 'horizontal',
			loop: false,
			autoHeight: true,
			autoplay: autoplay_int,
			pagination: {
				el: '.swiper-pagination-' + randomId,
				clickable: true,
				type: pagination_type
			},
			navigation: {
				nextEl: '[data-random="' + randomId + '"] .swiper-button-next',
				prevEl: '[data-random="' + randomId + '"] .swiper-button-prev'
			},
			on: {
				slideChangeTransitionStart: function (swiper) {
					swiper.el.parentNode.classList.toggle('changed', swiper.realIndex > 0);
					swiper.el.parentNode.classList.toggle('last-slide-active', swiper.realIndex + 1 === total_sl);
				}
			}
		});
	});
}

window.addEventListener("listTestimonialsSlider", function(event) {
	list_testimonials = document.querySelectorAll('.l4ts:not(.s4wi)');
	if (list_testimonials.length) {
		Array.from(list_testimonials).forEach(function (el) {
			var ln = [1, 2, 3],
				pagination_type = 'bullets',
				autoplay_int = false,
				total_sl = el.children.length,
				options;
			if (el.classList.contains('wide') || el.classList.contains('w100')) {
				ln = [1, 1, 1];
			}
			if (el.classList.contains('w50')) {
				ln = [1, 2, 2];
			}
			if (el.classList.contains('slider-fraction')) {
				pagination_type = 'fraction';
			}
			if (el.getAttribute('data-autoplay')) {
				autoplay_int = {
					delay: parseFloat(el.getAttribute('data-autoplay')),
					pauseOnMouseEnter: true,
					disableOnInteraction: false
				};
			}
			randomize(el);
			options = {
				direction: 'horizontal',
				loop: true,
				autoHeight: true,
				spaceBetween: 16,
				slidesPerView: ln,
				slidesPerGroup: ln,
				autoplay: autoplay_int,
				pagination: {
					el: '.swiper-pagination-' + el.getAttribute('data-random'),
					clickable: true,
					type: pagination_type,
					renderFraction: function (currentClass, totalClass) {
						return '<span class="' + currentClass + '"></span>' +
							' <span class="slash">/</span> ' +
							'<span class="' + totalClass + '"></span>';
					}
				},
				navigation: {
					nextEl: '[data-random="' + el.getAttribute('data-random') + '"] .swiper-button-next',
					prevEl: '[data-random="' + el.getAttribute('data-random') + '"] .swiper-button-prev'
				},
				on: {
					slideChangeTransitionStart: function (swiper) {
						swiper.el.parentNode.classList.toggle('changed', swiper.realIndex > 0);
						swiper.el.parentNode.classList.toggle('last-slide-active', swiper.realIndex + 1 === total_sl);
					}
				},
				breakpoints: {
					0: {
						slidesPerView: ln[0],
						slidesPerGroup: ln[0]
					},
					760: {
						slidesPerView: ln[1],
						slidesPerGroup: ln[1]
					},
					1000: {
						slidesPerView: ln[2],
						slidesPerGroup: ln[2]
					}
				}
			};
			if (el.classList.contains('slider') && el.children.length > ln[2]) {
				create_slider(el, options);
			}
			if (el.classList.contains('slider-mobile') && el.children.length > ln[0]) {
				const nextSibling = el.nextElementSibling;
				clone_with_class(el, 'mobile-only', 'mobile-hide');
				if (nextSibling && nextSibling.classList.contains('mobile-only')) {
					if (nextSibling.hasAttribute('id')) {
						nextSibling.removeAttribute('id');
					}
					create_slider(el.nextElementSibling, options);
				}
			}
		});
	}
});
window.dispatchEvent(listTestimonialsSliderEvt);

window.addEventListener("listStaticSlider", function(event) {
	list_static = document.querySelectorAll('.l4st:not(.s4wi)');
	if (list_static.length) {
		Array.from(list_static).forEach(function (el) {
			if (!el.classList.contains('static')) {
				var pagination_type = 'bullets',
					autoplay_int = false,
					total_sl = el.children.length;
				if (el.classList.contains('slider-fraction')) {
					pagination_type = 'fraction';
				}
				if (el.getAttribute('data-autoplay')) {
					autoplay_int = {
						delay: parseFloat(el.getAttribute('data-autoplay')),
						pauseOnMouseEnter: true,
						disableOnInteraction: false
					};
				}
				randomize(el);
				const randomId = el.getAttribute('data-random');
				clone_with_class(el, 'mobile-only', 'mobile-hide');
				if (el.nextElementSibling.classList.contains('mobile-only')) {
					if (el.nextElementSibling.hasAttribute('id')) {
						el.nextElementSibling.removeAttribute('id');
					}
					create_slider(el.nextElementSibling, {
						direction: 'horizontal',
						loop: true,
						autoHeight: true,
						spaceBetween: 16,
						autoplay: autoplay_int,
						pagination: {
							el: '.swiper-pagination-' + randomId,
							clickable: true,
							type: pagination_type,
							renderFraction: function (currentClass, totalClass) {
								return '<span class="' + currentClass + '"></span>' +
									' <span class="slash">/</span> ' +
									'<span class="' + totalClass + '"></span>';
							}
						},
						navigation: {
							nextEl: '[data-random="' + randomId + '"] .swiper-button-next',
							prevEl: '[data-random="' + randomId + '"] .swiper-button-prev'
						},
						on: {
							slideChangeTransitionStart: function (swiper) {
								swiper.el.parentNode.classList.toggle('changed', swiper.realIndex > 0);
								swiper.el.parentNode.classList.toggle('last-slide-active', swiper.realIndex + 1 === total_sl);
							}
						}
					});
				}
			}
			/*if (el.classList.contains('slider')) {
                randomize(el);
            }*/
		});
	}
});
window.dispatchEvent(listStaticSliderEvt);

window.addEventListener("listUspSlider", function(event) {
	list_usp = document.querySelectorAll('.l4us:not(.s4wi)');
	if (list_usp.length) {
		Array.from(list_usp).forEach(function (el) {
			if (!el.classList.contains('static')) {
				let autoplay_int = false;
				let autowidth_int = 1;
				let space_between;

				if (el.classList.contains('no-arrows')) {
					space_between = 16;
				} else {
					space_between = 44;
				}

				if (el.hasAttribute('data-autoplay')) {
					autoplay_int = {
						delay: parseFloat(el.getAttribute('data-autoplay')),
						pauseOnMouseEnter: true,
						disableOnInteraction: false
					};
				}
				randomize(el);
				const randomId = el.getAttribute('data-random');

				if (el.querySelectorAll('li').length === 1) {
					el.classList.remove('slider', 'slider-single');
				}
				if (el.closest('#nav-top') !== null && el.classList.contains('slider')) {
					el.classList.add('slider-in-header');
					if (!el.classList.contains('slider-single')) {
						autowidth_int = 'auto';
					}
				}
				const options = {
					direction: 'horizontal',
					loop: true,
					pagination: false,
					autoplay: autoplay_int,
					slidesPerView: autowidth_int,
					autoHeight: true,
					//spaceBetween: 10,
					spaceBetween: space_between,
					navigation: {
						nextEl: '[data-random="' + randomId + '"] .swiper-button-next',
						prevEl: '[data-random="' + randomId + '"] .swiper-button-prev'
					},
					breakpoints: {
						0: {
							slidesPerView: 1
						},
						760: {
							slidesPerView: autowidth_int
						},
						1000: {
							spaceBetween: space_between
						},
						1100: {
							spaceBetween: 20
						}
					}
				};
				if (!el.classList.contains('mobile-static')) {
					if (el.classList.contains('slider')) {
						create_slider(el, options);
					} else if (el.childNodes.length > 1) {
						clone_with_class(el, 'l4us-mobile', 'mobile-hide');
						const nextElement = el.nextElementSibling;
						if (nextElement.classList.contains('l4us-mobile')) {
							nextElement.classList.remove('slider', 'slider-in-header');
							if (nextElement.hasAttribute('id')) {
								nextElement.removeAttribute('id');
							}
							create_slider(nextElement, options);
						}
					}
				}
			}
		});
	}
});
window.dispatchEvent(listUspSliderEvt);

popup_a = document.getElementsByClassName('popup-a');
if (popup_a.length) {
	Array.from(popup_a).forEach(function (el) {
		Array.from(el.getElementsByClassName('l4cl')).forEach(function (el) {
			el.classList.add('in-popup');
		});
	});
}

list_collection_slider = document.querySelectorAll('.l4cl.slider:not(.in-popup, .s4wi), .l4ft.slider:not(.in-popup, .s4wi)');
const module_collection = document.getElementsByClassName('m6cl');
if (module_collection.length) {
	Array.from(module_collection).forEach(function (el) {
		Array.from(el.querySelectorAll('.l4cl.slider:not(.w12, .w14, .w16, .w20, .w25, .w33, .w50)')).forEach(function (el) {
			el.classList.add('in-col');
		});
	});
}

const list_collection = document.getElementsByClassName('l4cl');
if (list_collection.length) {
	Array.from(list_collection).forEach(el => {
		//if (el.classList.contains('hr')) {
			if (el.clientHeight < el.scrollHeight) {
				el.classList.add('is-scrollable');
			}
		//}
		Array.from(el.querySelectorAll('div.box')).forEach(em => {
			const closestLi = em.closest('li');
			if (closestLi) {
				closestLi.classList.add('has-div-box');
			}
		});
		Array.from(el.querySelectorAll('li')).forEach(em => {
			if (em.querySelectorAll('[class*="l4ml"]').length) {
				em.classList.add('has-l4ml');
			}
			if (em.querySelectorAll('picture ~ picture').length) {
				em.classList.add('has-picture-picture');
			}
		});
	});
}

window.addEventListener("listCollectionSlider", function(event) {
	list_collection_slider = document.querySelectorAll('.l4cl.slider:not(.in-popup, .s4wi), .l4ft.slider:not(.in-popup, .s4wi)');
	if (list_collection_slider.length) {
		Array.from(list_collection_slider).forEach(function (el) {
			var items, hasImg = false,
				autoHeight = true,
				loopMe = false,
				spacing = 16,
				//dist_a = parseFloat(getComputedStyle(el).getPropertyValue('--dist_a')),
				figureElement = el.querySelector('figure:not(:last-child)'),
				hasImg_H,
				allowTouch = true,
                allowTouch_760 = true,
				autoPlayMe = false,
				autoPlaySpeed = 300;
				// centered = false;

			if (el.matches('[style*="--dist_a"]')) {
                /*const dist_a = parseFloat(getComputedStyle(el).getPropertyValue('--dist_a'));
			    spacing = dist_a;*/
                const dist_a_value = getComputedStyle(el).getPropertyValue('--dist_a').trim();
                if (dist_a_value && dist_a_value !== 'px') {
                    const dist_a = parseFloat(dist_a_value);
                    if (!isNaN(dist_a)) {
                        spacing = dist_a;
                    }
                }
			}
			if (figureElement) {
				hasImg = true;
			} else {
				el.classList.add('no-img');
			}
			if (el.classList.contains('slider-loop')) {
				loopMe = true;
			}
			/*if (el.classList.contains('text-center')) {
				centered = true;
			}*/
			if (el.classList.contains('autoplay')) {
				autoPlayMe = {
					delay: 0,
				};
				loopMe = true;
				autoPlaySpeed = el.children.length * 1000;
			}
			if (el.classList.contains('static-height') && !el.classList.contains('align-stretch')) {
				autoHeight = false;
			}
            if (el.classList.contains('mobile-compact')) {
                allowTouch_760 = false;
            }
			if (el.classList.contains('static-height') || el.classList.contains('align-center') || el.classList.contains('align-stretch')) {
				allowTouch = true;
			}
			if (el.classList.contains('text-justify') || el.classList.contains('auto-width')) {
				items = ['auto', 'auto', 'auto'];
				autoHeight = false;
			} else {
				if (el.classList.contains('in-col')) {
					items = [4, 4, 3];
				} else if (el.classList.contains('w8')) {
					items = [12, 6, 4];
				} else if (el.classList.contains('w9')) {
					items = [11, 6, 4];
				} else if (el.classList.contains('w10')) {
					items = [10, 6, 4];
				} else if (el.classList.contains('w11')) {
					items = [9, 6, 4];
				} else if (el.classList.contains('w12')) {
					items = [8, 6, 4];
				} else if (el.classList.contains('w14')) {
					items = [7, 6, 4];
				} else if (el.classList.contains('w16')) {
					items = [6, 5, 3];
				} else if (el.classList.contains('w20')) {
					items = [5, 5, 3];
				} else if (el.classList.contains('w25')) {
					items = [4, 4, 3];
				} else if (el.classList.contains('w33')) {
					items = [3, 3, 3];
				} else if (el.classList.contains('w50')) {
					items = [2, 2, 2];
				} else {
					items = [5, 5, 3];
				}
			}
			randomize(el);
			const randomId = el.getAttribute('data-random');
			create_slider(el, {
				direction: 'horizontal',
				loop: loopMe,
				autoHeight: autoHeight,
				slidesPerView: items[0],
				focusableElements: 'input',
				spaceBetween: spacing,
				// centeredSlides: centered,
				touchStartPreventDefault: false,
				lazy: {
					loadPrevNext: true
				},
				pagination: {
					el: '.swiper-pagination-' +randomId,
					clickable: true
				},
				navigation: {
					nextEl: '[data-random="' + randomId + '"] .swiper-button-next',
					prevEl: '[data-random="' + randomId + '"] .swiper-button-prev'
				},
				autoplay: autoPlayMe,
				speed: autoPlaySpeed,
				breakpoints: {
					0: {
                        simulateTouch: false,
                        allowTouchMove: false
					},
					760: {
						slidesPerView: items[2],
						simulateTouch: allowTouch_760,
						allowTouchMove: allowTouch_760
					},
					1000: {
						slidesPerView: items[1],
						simulateTouch: allowTouch,
						allowTouchMove: allowTouch
					},
					1100: {
						slidesPerView: items[0],
						simulateTouch: allowTouch,
						allowTouchMove: allowTouch
					}
				},
				on: {
					afterInit: function (swiper) {
						// handleInit();
						window.dispatchEvent(lazyVideoEvt);
					},
          resize: handleInit,
          transitionStart: function (swiper) {
            swiper.el.classList.add('transition');
          },
          transitionEnd: function (swiper) {
            swiper.el.classList.remove('transition');
          }
				}
			});
			let handleInitCalculated = false;
			//if (!isHasSelectorSupported()) {
			Array.from(el.getElementsByClassName('has-text')).forEach(function (em) {
				em.parentElement.classList.add('has-text');
			});
			Array.from(el.getElementsByClassName('cols')).forEach(function (em) {
				em.parentElement.classList.add('has-cols');
			});
			//}
			function handleInit(swiper) {
				if(!handleInitCalculated){
					if (hasImg === true) {
						const firstFig = el.querySelector('.swiper-slide-active figure');
						if (firstFig) {
                            if (firstFig.offsetHeight === 0) {
								el.style.removeProperty('--fih');
							} else {
                                el.style.setProperty('--fih', firstFig.offsetHeight + 'px');
							}
						}
					}
					handleInitCalculated = true;
				}
			}


			if (hasImg === true) {
				if (!isMobile) {
					document.addEventListener('mouseover', handleInit);
				}
				document.addEventListener('keyup', handleInit);
				document.addEventListener('touchstart', handleInit);
				document.addEventListener('scroll', handleInit);
				window.addEventListener('resize', function(){
					setTimeout(function () {
						handleInitCalculated = false;
						handleInit();
					},5);
				});

				const closestTabs = el.closest('.m6tb');
				if (closestTabs) {
					const links = closestTabs.children[0].querySelectorAll('a');
					links.forEach(link => {
						link.addEventListener('click', () => {
							setTimeout(function () {
								handleInitCalculated = false;
								handleInit();
							}, 100);
						});
					});
				}

				const handleIntersection = (entries, observer) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							handleInit();
							observer.unobserve(entry.target);
						}
					});
				};

				const observer = new IntersectionObserver(handleIntersection, {
					root: null,
					rootMargin: '0px',
					threshold: 0.5,
				});

				observer.observe(el);

				if (el.closest('li.sub') !== null) {
					el.closest('li.sub').addEventListener('mouseenter', function () {
						setTimeout(function () {
							handleInitCalculated = false;
							handleInit();
						}, 100);
					});
				}
			}
			const wrapperId = el.querySelector('.swiper-wrapper[id]');
			if (wrapperId) {
				wrapperId.removeAttribute('id');
				Array.from(el.querySelectorAll('.swiper-button-nav[aria-controls]')).forEach(em => {
					em.removeAttribute('aria-controls');
				});
			}
		});
	}
});
window.dispatchEvent(listCollectionSliderEvt);

window.addEventListener("listProductSlider", function(event) {
	const list_product_slider = document.querySelectorAll('.l4pr:not(.s4wi)');
	if (list_product_slider.length) {
        html_tag.classList.add('t1pr');
		Array.from(list_product_slider).forEach(function (el) {
			var hasStickyNote = false;
			var stickyNote = [];
			if (el.classList.contains('static')) {
				var clone_me = el.cloneNode(true);
				clone_me.classList.remove('static');
				clone_me.classList.add('desktop-hide');
				el.classList.add('desktop-only');
				el.after(clone_me);
				el = el.nextElementSibling;
			}
      // else {
			// 	var stickyNotes = el.querySelectorAll('li.sticky');
			// 	if (stickyNotes.length) {
			// 		hasStickyNote = true;
			// 		stickyNote = Array.from(stickyNotes);
			// 		stickyNotes.forEach(child => child.remove());
			// 	}
			// }
			var mainSliderElement = el,
				children = mainSliderElement.children,
				qttChildren = children.length,
				total_sl = el.children.length,
				mainSlider,
				slides,
				initial_slide = 0;

      const stickyNotes = mainSliderElement.querySelectorAll('li.sticky');
      if (stickyNotes.length) {
        hasStickyNote = true;
        stickyNote = Array.from(stickyNotes);
        stickyNotes.forEach(child => child.remove());
      }

			const firstModel = mainSliderElement.querySelectorAll('a > .model-3d:first-child model-viewer[poster]');
			Array.from(firstModel).forEach(em => {
				const staticPosterWrapper = document.createElement('picture');
				const posterSrc = em.getAttribute('poster');

				const staticPoster = document.createElement('img');
				staticPoster.setAttribute('src', posterSrc);
				staticPoster.setAttribute('data-src', posterSrc);
				staticPosterWrapper.prepend(staticPoster);

				staticPosterWrapper.classList.add('just-poster');

				const altAttribute = em.getAttribute('alt');
				if (altAttribute) {
					staticPoster.setAttribute('alt', altAttribute);
				}

				const closestLink = em.closest('a');
				if (closestLink) {
					closestLink.prepend(staticPosterWrapper);
				}
			});

			if (!el.classList.contains('thumbs-static') && !el.classList.contains('thumbs-slider')) {
				const fifthChild = children[4];

				if (fifthChild) {
					fifthChild.classList.add('more');
					append_url(fifthChild, '+' + (qttChildren - 5), 'more');
				}
				/*if (typeof children[5] !== 'undefined') {
                    children[4].classList.add('more');
                    append_url(children[4], '+' + qttChildren - 5, 'more');
                }*/
			}

			const featuredMediaPosition = el.getAttribute('data-featured_media_position');
			if (featuredMediaPosition) {
				initial_slide = parseFloat(featuredMediaPosition) - 1;
			}

			// clone all slides before swiper uses them and change the DOM - used to create custom pagination
			slides = mainSliderElement.cloneNode(true).children;
			Array.from(el.getElementsByClassName('m6bx')).forEach(em => {
				em.classList.add('m6bx-inside');
				el.firstElementChild.appendChild(em);
				em.parentElement.removeChild(em);
			});
			randomize(el);
			const randomId = el.getAttribute('data-random');
			function setNavigationHeight(swiper) {
				const h = `${swiper.height}px`;
                swiper.navigation.prevEl.style.height = h;
                swiper.navigation.nextEl.style.height = h;
            }
			mainSlider = create_slider(mainSliderElement, {
				direction: 'horizontal',
				loop: false,
				autoHeight: true,
				preloadImages: false,
				initialSlide: initial_slide,
				pagination: {
					el: '.swiper-pagination-' + randomId,
					clickable: true,
					renderBullet: function (index, className) {
						var finalSpan = document.createElement("a"),
							img_type,
							add_class,
							img,
							divFlex,
							moreLink,
							icon,
							span,
							a_thumb,
							a_thumb_img,
							a_thumb_pic,
							a_thumb_pic_class;
						finalSpan.classList.add(className);
						if (slides[index].hasAttribute('class')) {
                            add_class = slides[index].getAttribute('class');

                            const orientationClasses = ['portrait', 'landscape', 'square', 'stripe'];

                            orientationClasses.forEach(orientation => {
                                if (add_class.includes(orientation)) {
                                    finalSpan.classList.add(`orientation-${orientation}`);
                                }
                            });
                            if (add_class.includes('auto')) {
                                finalSpan.classList.add('auto');
                                finalSpan.classList.remove('landscape', 'portrait');
                            }
						}
						if (slides[index].querySelector("picture")) {
							img_type = 'picture';
						} else {
							img_type = 'img';
						}
						img = slides[index].querySelector(img_type);
						if (img !== null) {
							const a_thumb = img.closest('a[data-gallery-thumb]');
							const a_thumb_img = document.createElement('img');
							const a_thumb_pic = document.createElement('picture');

							if (a_thumb) {
								const thumbSrc = a_thumb.getAttribute('data-gallery-thumb');
								a_thumb_img.setAttribute('src', thumbSrc);

								const a_thumb_pic_class = a_thumb.querySelector('picture[class]');
								if (a_thumb_pic_class) {
									const classValue = a_thumb_pic_class.getAttribute('class');
									const classes = classValue.split(' ');
									classes.forEach(className => {
                                        if (className) {
                                            a_thumb_pic.classList.add(className);
                                        }
									});
								}

								a_thumb_img.setAttribute('alt', 'Thumbnail');
								a_thumb_pic.appendChild(a_thumb_img);
								finalSpan.appendChild(a_thumb_pic);
							} else if (img) {
								finalSpan.appendChild(img);
							}
						}

						divFlex = document.createElement("span");

						moreLink = slides[index].querySelector("a.more");
						if (moreLink && ((qttChildren - 1) - index) > 0) {
							span = document.createElement("span");
							span.innerText = '+' + ((qttChildren - 1) - index).toString();

							divFlex.appendChild(span);
							finalSpan.classList.add('has-more');
							if (slides[index].querySelectorAll('a[data-fancybox]')) {
								Array.from(slides[index].querySelectorAll('a[data-fancybox]')).forEach(function (em) {
									finalSpan.setAttribute('href', em.getAttribute('href'));
								});
							}
						}

						icon = slides[index].querySelector("i[class^=icon-]");
						if (icon) {
							divFlex.appendChild(icon);
						}

						finalSpan.appendChild(divFlex);

						return finalSpan.outerHTML;
					}
				},
				navigation: {
					nextEl: '[data-random="' + el.getAttribute('data-random') + '"] .swiper-button-next',
					prevEl: '[data-random="' + el.getAttribute('data-random') + '"] .swiper-button-prev'
				},
				on: {
					// "this" keyword within event handler always points to Swiper instance (from documentation https://swiperjs.com/swiper-api#events)
					activeIndexChange: function () {
						var activeIndex = this.activeIndex;
						Array.from(this.el.parentNode.getElementsByClassName('custom-progressbar-inner')).forEach(function (el) {
							el.style.width = 100 * (activeIndex + 1) / qttChildren + '%';
						});
					},
					afterInit: function (swiper) {
						// create progress bar
						const progress_bar = createElementWithClass('div', 'custom-progressbar');
						progress_bar.innerHTML = '<div class="custom-progressbar-inner" style="width:' + 100 / qttChildren + '%;"></div>';
						swiper.el.appendChild(progress_bar);

						Array.from(swiper.el.querySelectorAll('.s1lb, .label')).forEach(em => {
							swiper.el.parentNode.appendChild(em);
						});
						Array.from(swiper.el.getElementsByClassName('m6bx-inside')).forEach(em => {
							swiper.el.appendChild(em);
						});

						let custom_fraction;
						if (el.classList.contains('no-thumbs-mobile') || el.classList.contains('slider-fraction')) {
							custom_fraction = swiper.el.parentNode.querySelector('.swiper-custom-fraction');
							custom_fraction.innerHTML = '<span class="swiper-pagination-current">1</span> <span class="slash">/</span> <span class="total-el">' + swiper.slides.length + '</span>';
						}

						setTimeout(function () {
							setNavigationHeight(swiper);
						}, 300);
					},
					slideChangeTransitionEnd: function (swiper) {
						setTimeout(function () {
							setNavigationHeight(swiper);
						}, 300);
					},
					slideChangeTransitionStart: function (swiper) {
						setTimeout(function () {
							if (el.classList.contains('no-thumbs-mobile') || el.classList.contains('slider-fraction')) {
								var custom_fraction = swiper.el.parentNode.getElementsByClassName('swiper-pagination-current')[0];
								custom_fraction.innerHTML = swiper.realIndex + 1;
								if (swiper.realIndex > 0) {
									swiper.el.classList.add('changed');
								} else {
									swiper.el.classList.remove('changed');
								}
							}
							if (swiper.realIndex + 1 === total_sl) {
								swiper.el.classList.add('last-slide-active');
							} else {
								swiper.el.classList.remove('last-slide-active');
							}
						}, 300);
					},
					resize: function (swiper) {
						setNavigationHeight(swiper);
					}
				}
			});

			if (hasStickyNote = true) {
				stickyNote.forEach(function (imgOverlay) {
					const swiperOuter = el.querySelector('.swiper-outer');
					if (swiperOuter !== null) {
						swiperOuter.appendChild(imgOverlay);
					} else {
						el.appendChild(imgOverlay);
					}
				});
			}

			function assignSlideIndex(elements) {
				'use strict';
				Array.from(elements).forEach((el, index) => {
					el.style.zIndex = elements.length - index;
				});
			}

			if (el.classList.contains('thumbs-slider')) {
				const randomIdSelector = '[data-random="' + randomId + '"]';
				const bulletsSelector = `${randomIdSelector} .swiper-pagination-bullets`;
				const customBullets = el.querySelector(bulletsSelector);

				clone_with_class(customBullets, 'cloned', 'hidden');

				const clonedBullets = el.querySelector(`${bulletsSelector}.cloned`);

				Array.from(clonedBullets.children).forEach((bullet, index) => {
					bullet.setAttribute('data-l4pr-index', index);
				});

				create_slider(clonedBullets, {
					direction: 'horizontal',
					loop: false,
					autoHeight: false,
					slidesPerView: 'auto',
					navigation: {
						nextEl: `${bulletsSelector} .swiper-button-next`,
						prevEl: `${bulletsSelector} .swiper-button-prev`
					}
				});
			}

      /*const data_update_product_slider = document.querySelectorAll('[data-l4pr-index]');
      if (data_update_product_slider.length) {
        Array.from(data_update_product_slider).forEach(el => {
          const isOption = el.tagName.toLowerCase() === 'option';
          const clickHandler = e => {
            const index = parseInt(el.getAttribute('data-l4pr-index'));
            mainSlider.slideTo(index);

            if (el.tagName.toLowerCase() === 'a' && el.classList.contains('swiper-pagination-bullet')) {
              const slide = el.closest('.swiper-slide');
              const siblings = Array.from(getSiblings(slide));

              siblings.forEach(em => {
              em.firstElementChild.classList.remove('swiper-pagination-bullet-active');
              });

              el.classList.add('swiper-pagination-bullet-active');
              e.preventDefault();
            }
          };

          if (isOption) {
            const em = el.parentNode;
            em.addEventListener('change', () => {
              const dx = em.options[em.selectedIndex].getAttribute('data-l4pr-index');
              if (dx !== null) {
                mainSlider.slideTo(dx);
              }
            });
          } else {
            el.addEventListener('click', clickHandler);
          }
        });
      }*/
		});
	}
});
window.dispatchEvent(listProductSliderEvt);

//Default.utils.ratings();
window.addEventListener("ratings", function(evt) {
	const ratingElements = document.querySelectorAll('[data-val][data-of]:not(.rating-initialized)');

	if (ratingElements.length) {
		Array.from(ratingElements).forEach(el => {
			el.classList.add('rating-initialized');
			const fragment = document.createDocumentFragment();
			const reviewsElem = createElementWithClass('span', 'rating-label');
			const reviews = el.innerHTML;
			const rating = el.dataset.val;
			const total = el.dataset.of;

			const isNotS1ld = !(el.classList.contains('s1ld') || el.classList.contains('s1br'));

			if (isNotS1ld) {
				fragment.appendChild(createRatingsHtmlElement(rating, total));
				reviewsElem.innerHTML = reviews;
			} else {
				reviewsElem.innerHTML = `<span class="bar" style="width: ${rating / total * 100}%;"></span>`;
			}

			fragment.appendChild(reviewsElem);
			el.textContent = '';
			el.appendChild(fragment);
		});
	}
});
window.dispatchEvent(ratingsEvt);

const alignMiddleElements = document.getElementsByClassName('align-middle');
const alignCenterElements = document.getElementsByClassName('align-center');

function checkAndAddClass(elements, className) {
	if (elements.length) {
		Array.from(elements).forEach(el => {
			const parent = el.parentNode;
			const grandparent = parent.parentNode;

			const isCenterElement = (
				(el.previousElementSibling === null && el.nextElementSibling === null && parent.id === 'content') ||
				(el.previousElementSibling === null && el.nextElementSibling === null && parent.previousElementSibling === null && parent.nextElementSibling === null && grandparent.id === 'content')
			);

			if (isCenterElement) {
				document.getElementById('content').classList.add(className);
			}
		});
	}
}

//Default.utils.background();
checkAndAddClass(alignMiddleElements, 'align-center');
checkAndAddClass(alignCenterElements, 'align-center-static');

if (!isHasSelectorSupported()) {
	const list_featured_content_box = document.querySelectorAll('.l4ft .content.box');
	if (list_featured_content_box.length) {
		Array.from(list_featured_content_box).forEach(el => {
			const closestLi = el.closest('li');
			if (closestLi) {
				closestLi.classList.add('has-content-box');
			}
		});
	}
}

//Default.utils.mobile();
if (isMobile) {
	html_tag.classList.add('mobile');
} else {
	html_tag.classList.add('no-mobile');
}

//Default.utils.done();
new_js(window.filepaths['scripts_async_js']);

window.addEventListener("mediaFlexbile", function(evt) {
  const media_flexible = document.getElementsByClassName('media-flexible');
  if (media_flexible.length) {
    Array.from(media_flexible).forEach(function (el) {
      if ((!el.parentElement.classList.contains('flexible-stack') && (el.classList.contains('slider-mobile') || el.parentElement.classList.contains('mobile-static'))) && (!el.classList.contains('media-flexible-initialized'))) {
        var cloned_mobile, link, emc, pt = el.parentElement,
          tag = document.createElement('div'),
          fl = pt.querySelectorAll('.media-flexible:not(.mobile-hide-media-flexible) > *:not(.mobile-hide-media-flexible)');
        if (!el.parentElement.getElementsByClassName('media-flexible-mobile').length) {
          tag.classList.add('media-flexible-mobile');
          el.after(tag);
          el.classList.add('mobile-hide');
          const cloned_mobile = pt.querySelector('.media-flexible-mobile');
          Array.from(fl).forEach(function (em) {
            emc = em.cloneNode(true);
            cloned_mobile.appendChild(emc);
          });
  
          if (cloned_mobile.classList.contains('media-flexible-mobile')) {
            cloned_mobile.classList.remove('media-flexible', 'mobile-hide');
            if (cloned_mobile.hasAttribute('id')) {
              cloned_mobile.removeAttribute('id');
            }
  
            Array.from(cloned_mobile.children).forEach(function (el) {
              if (el.classList.contains('mobile-hide')) {
                el.remove();
              }
            });
            randomize(cloned_mobile);
            const randomId = cloned_mobile.getAttribute('data-random');
            if (!cloned_mobile.classList.contains('s4wi')) {
              create_slider(cloned_mobile, {
                direction: 'horizontal',
                loop: true,
                autoHeight: true,
                pagination: {
                  el: '.swiper-pagination-' + randomId,
                  clickable: true,
                  type: 'bullets',
                  renderBullet: function (index, className) {
                    return '<span class="' + className + '">' + (index + 1) + "<span class='prg'></span></span>";
                  }
                },
                on: {
                  slideChangeTransitionStart: function (swiper) {
                    var active_content = swiper.el.querySelectorAll('.swiper-slide[data-swiper-slide-index="' + swiper.realIndex + '"] > *')[0];
                    if (typeof active_content !== 'undefined') {
                      el.closest('.m6fr').setAttribute('data-active-content', active_content.getAttribute('data-color-palette'));
                    }
                  }
                }
              });
            }
          }
        }
        el.classList.add('media-flexible-initialized');
      }
    });
  }
  });
  window.dispatchEvent(mediaFlexibleEvt);

/*!*/
window.addEventListener("createCols", function(event) {
	var servicePageElement = document.querySelector('[id$="page-service-info-blocks"]');
	if (servicePageElement != null) {
		if (servicePageElement.parentElement.classList.contains('cols')) {
			var parent = servicePageElement.parentElement;
			var article = servicePageElement.parentElement.querySelector('article.w64.t55');
			if (article) { article.replaceWith(...article.childNodes); }
			parent.replaceWith(...parent.childNodes);
		}

		var anySiblingFound = false;
		var wrapper = document.createElement('div');
		wrapper.classList.add('cols');
		var wrapperInner = document.createElement('article');
		wrapperInner.classList.add('w64','t55');
		wrapper.appendChild(wrapperInner);
		var possibleSiblings = ['shopify-section-page-service-menu', 'shopify-section-faq', 'shopify-section-contact-form', 'shopify-section-google-maps'];

		var findSibling = function() {
			var prevSibling = servicePageElement.previousSibling;
			if (prevSibling) {
				var correctSiblingFound = false;
				for (var i = 0; i < possibleSiblings.length; i++) {
					if (prevSibling.classList.contains(possibleSiblings[i])) {
						correctSiblingFound = true;
						anySiblingFound = true;
						prevSibling.classList.add('w64','t55')
						wrapperInner.appendChild(prevSibling);
					}
				}
				if (correctSiblingFound) {
					findSibling();
				} else {
					for (var i = 1; i < wrapperInner.childNodes.length; i++){
						wrapperInner.insertBefore(wrapperInner.childNodes[i], wrapperInner.firstChild);
					}
					if (anySiblingFound) {
						servicePageElement.parentNode.insertBefore(wrapper, servicePageElement);
						wrapper.appendChild(servicePageElement);
					}
				}
			}
		}
		findSibling();
	}
});
window.dispatchEvent(createColsEvt);

window.addEventListener("showAlert", function(event) {
	var messageText = event.detail.message,
		messageType = event.detail.type,
		messageHeader = event.detail.header ? event.detail.header : false,
		messageOrigin = event.detail.origin ? 'message-' + event.detail.origin : false,
		messageColor = '';
	switch(messageType) {
		case "success":
			messageColor = 'lime';
			if (!messageHeader) { messageHeader = window.translations.general_alerts_success_text; }
			break;
		case "info":
			messageColor = 'pine';
			if (!messageHeader) { messageHeader = window.translations.general_alerts_info_text; }
			break;
		case "error":
			messageColor = 'rose';
			if (!messageHeader) { messageHeader = window.translations.general_alerts_error_text; }
			break;
		default:
			messageColor = 'lime';
			if (!messageHeader) { messageHeader = ''; }
	}
	var message = '<li class="overlay-'+ messageColor +' '+ messageOrigin +'"><i aria-hidden="true" class="icon-'+ messageType +'"></i><p class="strong">'+ messageHeader +'</p><p>'+ messageText +'</p><a href="./" class="close">Close</a></li>';
	var list_alerts = document.querySelector('.l4al:not(.inline):not(.l4al-trustbadge)');

	if (list_alerts === null) {
		list_alerts = document.createElement("ul");
		list_alerts.classList.add('l4al', 'fixed');
		document.getElementById('root').appendChild(list_alerts);
	}
	if ((messageOrigin && list_alerts.getElementsByClassName(messageOrigin).length == 0) || !messageOrigin) { // Prevent double messages (multiple of the same forms are being triggered when posted in shopfiy)
		list_alerts.innerHTML += message;
	}
	if (typeof alertsEvt != 'undefined') { window.dispatchEvent(alertsEvt); }
}, false);

function scrollToTargetAdjusted(el) {
	if ('scrollRestoration' in history) {
		history.scrollRestoration = 'manual';
	}
	el.scrollIntoView({
		block: 'center'
	});
}
let loadMoreItemClicked = localStorage.getItem('loadMoreItemClicked');
if (loadMoreItemClicked != null) {
	let el = document.querySelector('#collection > li > figure > a[href="'+ loadMoreItemClicked +'"], .m6cl .results > div a[href="'+ loadMoreItemClicked +'"], .m6cl .results > .l4ne a[href="'+ loadMoreItemClicked +'"]'),
		url = window.location.href;
	if (el && !url.includes(loadMoreItemClicked)) {
		scrollToTargetAdjusted(el);
		localStorage.removeItem('loadMoreItemClicked');
	} else if (!url.includes(loadMoreItemClicked)) {
		localStorage.removeItem('loadMoreItemClicked');
	}
}

window.addEventListener("lazyVideo", function(evt) {
	var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));
	if ("IntersectionObserver" in window) {
		var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
			entries.forEach(function(video) {
				if (video.isIntersecting) {
					for (var source in video.target.children) {
						var videoSource = video.target.children[source];
						if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
							videoSource.src = videoSource.dataset.src;
						}
					}

					video.target.load();
					video.target.classList.remove("lazy");
					lazyVideoObserver.unobserve(video.target);
				}
			});
		});

		lazyVideos.forEach(function(lazyVideo) {
			lazyVideoObserver.observe(lazyVideo);
		});
	}
});
document.addEventListener("DOMContentLoaded", function() {
	window.dispatchEvent(lazyVideoEvt);
});

// Animations .t1an
var a_js_animations = 'js/plugin-animations.js';
var a_css_animations = 'styles/async-animations.css';
function loadRes(u, c, i) {
	'use strict';
	if (html_tag.classList.contains(i)) {
		c();
		return true;
	}
	var s = document.createElement('script');
	s.src = u;
	s.async = true;
	s.onload = c;
	document.body.appendChild(s);
	if (!html_tag.classList.contains(i)) {
		html_tag.classList.add(i);
	}
	return true;
}
// NOTE: this plugin will animate only the elements with the [data-sal] attribute defined.
var data_sal = document.querySelectorAll('[data-sal]');
if (data_sal.length) {
	loadRes(a_js_animations, function () {
		"use strict";
		new_css('animations-css', a_css_animations);
		sal({
			threshold: 1,
			once: true
		});
	});
}

// Fix: Xtra cart note toggle navigates to homepage (href="./")
document.addEventListener('click', function (e) {
  var toggle = e.target.closest('label[for^="note"] a.toggle');
  if (toggle) e.preventDefault();
}, true);


/* ===== Cart drawer upsell: skuffe + pile + mouse-drag ===== */
(function(){
  function initUpsell(){
    var box = document.querySelector('aside#cart .cart-upsell.pb-clone');
    if(!box) return;
    var ul = box.querySelector('ul.l4ca.in-panel');
    var h3 = box.querySelector('h3');
    if(!ul || !h3) return;
    if(ul.dataset.pbSlider) return;
    ul.dataset.pbSlider = '1';

	// flyt upsell-boksen ind i den sticky bund, lige over totalen
    var total = document.querySelector('aside#cart ul.l4tt');
    if(total && box.parentElement !== total.parentElement){
      total.parentElement.insertBefore(box, total);
    }

    // header: titel + pile + chevron
    var head = document.createElement('div'); head.className = 'pb-upsell-head';
    h3.parentNode.insertBefore(head, h3); head.appendChild(h3);
	    ['font-size:16px','font-weight:700','line-height:1.3','margin:0'].forEach(function(d){
      var p=d.split(':'); h3.style.setProperty(p[0],p[1],'important');
    });
    var nav = document.createElement('div'); nav.className = 'pb-upsell-nav';
    nav.innerHTML = '<button type="button" class="pb-prev" aria-label="Previous">&#8249;</button><button type="button" class="pb-next" aria-label="Next">&#8250;</button>';
    head.appendChild(nav);
    var chev = document.createElement('button'); chev.type = 'button'; chev.className = 'pb-toggle'; chev.setAttribute('aria-label','Toggle');
    chev.innerHTML = '<i aria-hidden="true" class="icon-chevron-down"></i>';
    head.appendChild(chev);
    box.classList.add('pb-collapsed');
    head.addEventListener('click', function(e){
      if(e.target.closest('.pb-upsell-nav')) return;
      box.classList.toggle('pb-collapsed');
      if(!box.classList.contains('pb-collapsed')) setTimeout(update, 50);
    });
    var prev = nav.querySelector('.pb-prev'), next = nav.querySelector('.pb-next');

    // slider
    function cards(){ return Array.prototype.slice.call(ul.querySelectorAll(':scope > li')); }
    function nearestIndex(){
      var x = ul.scrollLeft, best = 0, bd = Infinity;
      cards().forEach(function(li,i){ var d = Math.abs(li.offsetLeft - ul.offsetLeft - x); if(d<bd){bd=d;best=i;} });
      return best;
    }
    function goTo(i, smooth){
      var c = cards(); if(!c.length) return;
      i = Math.max(0, Math.min(c.length-1, i));
      ul.scrollTo({left: c[i].offsetLeft - ul.offsetLeft, behavior: smooth===false ? 'auto' : 'smooth'});
    }
    function update(){
      if(!ul.clientWidth){ prev.disabled = next.disabled = false; return; }
      prev.disabled = ul.scrollLeft <= 2;
      next.disabled = ul.scrollLeft + ul.clientWidth >= ul.scrollWidth - 2;
    }
    prev.addEventListener('click', function(){ goTo(nearestIndex()-1); });
    next.addEventListener('click', function(){ goTo(nearestIndex()+1); });
    ul.addEventListener('scroll', update, {passive:true});
    if(window.ResizeObserver) new ResizeObserver(update).observe(ul);
    update();

    // mouse-drag (pointer events + capture)
    var down=false, startX=0, startL=0, moved=false, pid=null;
    ul.addEventListener('dragstart', function(e){ e.preventDefault(); });
            /* undgå fokus-scroll ved klik på knapper i delvist synlige kort */
    ul.addEventListener('mousedown', function(e){ if(e.target.closest('button, a')) e.preventDefault(); });
    ul.addEventListener('pointerdown', function(e){
      if(e.pointerType!=='mouse' || e.button!==0 || e.target.closest('button')) return;
      down=true; moved=false; startX=e.clientX; startL=ul.scrollLeft; pid=e.pointerId;
      try{ ul.setPointerCapture(pid); }catch(_){}
      ul.classList.add('pb-dragging'); e.preventDefault();
    });
    ul.addEventListener('pointermove', function(e){
      if(!down) return;
      var dx = e.clientX - startX; if(Math.abs(dx)>4) moved=true;
      ul.scrollLeft = startL - dx;
    });
    function endDrag(){
      if(!down) return; down=false;
      try{ if(pid!==null) ul.releasePointerCapture(pid); }catch(_){}
      pid=null; ul.classList.remove('pb-dragging');
      if(moved) goTo(nearestIndex());
    }
    ul.addEventListener('pointerup', endDrag);
    ul.addEventListener('pointercancel', endDrag);
    ul.addEventListener('lostpointercapture', endDrag);
    window.addEventListener('blur', endDrag);
    document.addEventListener('visibilitychange', function(){ if(document.hidden) endDrag(); });
    ul.addEventListener('click', function(e){ if(moved){ e.preventDefault(); e.stopPropagation(); moved=false; } }, true);
  }
  initUpsell();
  var cart = document.querySelector('aside#cart') || document.body;
  new MutationObserver(function(){ initUpsell(); }).observe(cart, {childList:true, subtree:true, attributes:true, attributeFilter:['class']});
})();

/* ===== PB NAV 18-09-26: landekode-badges (GB/JP/CN/KR) + "Se alt X"-række øverst i hvert dropdown-panel (desktop-CSS i screen-settings) ===== */
(function(){
  function run(){
    var LC=(document.documentElement.lang||'en').slice(0,2);
    var TX={da:'Se alt',en:'See all',de:'Alle anzeigen',sv:'Se allt',nb:'Se alt',no:'Se alt',nl:'Bekijk alles',fi:'N\u00e4yt\u00e4 kaikki',pl:'Zobacz wszystko',it:'Vedi tutto',fr:'Voir tout',es:'Ver todo'};
    var pre=TX[LC]||TX.en, CC={EN:'GB',JP:'JP',CN:'CN',KR:'KR'};
    document.querySelectorAll('nav#nav > ul > li > ul.wide > li > ul > li > a:not(.toggle)').forEach(function(a){
      if(!a.parentElement.querySelector(':scope > ul')) return; // kun grupper m. undermenu (temaet sætter .sub senere)
      if(a.dataset.cc) return;
      var h=(a.getAttribute('href')||'').toLowerCase(), t=a.textContent.trim();
      var cc = /(^|[-\/])(en|english)($|[-\/])/.test(h) ? 'GB'
             : /(^|[-\/])(jp|jpn|japanese)($|[-\/])/.test(h) ? 'JP'
             : /(^|[-\/])(cn|chinese)($|[-\/])/.test(h) ? 'CN'
             : /(^|[-\/])(kr|korean)($|[-\/])/.test(h) ? 'KR'
             : /\b(english|engelsk|englisch|anglais|ingl[e\u00e9]s|inglese|engels|engelska|englan\w*|angielsk\w*|EN)\b/i.test(t) ? 'GB'
             : /\b(japanese|japansk|japanisch|japonais|japon[e\u00e9]s|giapponese|japans|japanska|japani\w*|japo\u0144sk\w*|JP)\b/i.test(t) ? 'JP'
             : /\b(chinese|kinesisk|chinesisch|chinois|chino|cinese|chinees|kinesiska|kiina\w*|chi\u0144sk\w*|CN)\b/i.test(t) ? 'CN'
             : /\b(korean|koreansk|koreanisch|cor[e\u00e9]en|coreano|koreaans|koreanska|korea\w*|korea\u0144sk\w*|KR)\b/i.test(t) ? 'KR' : '';
      if(cc) a.dataset.cc=cc;
    });
    document.querySelectorAll('nav#nav > ul > li.sub > ul.wide').forEach(function(w){
      if(w.querySelector(':scope > li.pb-nav-all')) return;
      var top=w.parentElement.querySelector(':scope > a:not(.toggle)');
      var href=top && top.getAttribute('href'); if(!href || href==='#') return;
      var li=document.createElement('li'); li.className='pb-nav-all';
      var a=document.createElement('a'); a.href=href; a.textContent=pre+' '+top.textContent.trim();
      li.appendChild(a); w.insertBefore(li, w.firstChild);
    });
  }
  // Luk panelet når musen forlader menupunktet (temaet fjerner ikke .hover på det kompakte panel)
  function closeOnLeave(){
    if(!window.matchMedia('(min-width:1001px)').matches) return;
    document.querySelectorAll('nav#nav > ul > li').forEach(function(li){
      if(li.dataset.pbLeave) return; li.dataset.pbLeave='1'; var t;
      li.addEventListener('mouseenter', function(){ clearTimeout(t); });
      li.addEventListener('mouseleave', function(){ t=setTimeout(function(){ li.classList.remove('hover'); }, 60); });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', closeOnLeave); else closeOnLeave();
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', run); else run();
})();


/* ===== PB NAV MOBIL v3 18-09-26: panel-position under burgeren + luk ved klik udenfor ===== */
(function(){
  function burger(){ return document.querySelector('#header-inner a.text-justify'); }
  function setTop(){ var b=burger(); if(!b) return; var r=b.getBoundingClientRect(); document.documentElement.style.setProperty('--pb-nav-top', Math.round(r.bottom+16)+'px'); }
  function init(){
    setTop(); window.addEventListener('resize', setTop); window.addEventListener('scroll', setTop, {passive:true});
    var b=burger(); if(b) b.addEventListener('click', setTop, true);
    document.addEventListener('click', function(e){
      if(!document.documentElement.classList.contains('m2a')) return;
      var nav=document.querySelector('nav#nav'); if(!nav) return;
      if(nav.contains(e.target) || e.target.closest('#header-inner a.text-justify')) return;
      var cl=nav.querySelector('a.close-nav'); if(cl) cl.click();
    }, true);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init); else init();
})();


/* ===== PB NAV MOBIL v4 18-09-26: "Tilbage" i stedet for "Alle kollektioner", tease-linje under hovedpunkter, swipe-venstre lukker panelet ===== */
(function(){
  function run(){
    var LC=(document.documentElement.lang||'en').slice(0,2);
    var BK={da:'Tilbage',en:'Back',de:'Zur\u00fcck',sv:'Tillbaka',nb:'Tilbake',no:'Tilbake',nl:'Terug',fi:'Takaisin',pl:'Wstecz',it:'Indietro',fr:'Retour',es:'Atr\u00e1s'};
    function renameBack(){ var t=BK[LC]||BK.en; document.querySelectorAll('nav#nav a.toggle-back').forEach(function(a){ if(a.textContent!==t) a.textContent=t; }); document.querySelectorAll('nav#nav > ul.nav-top li.currency > a.toggle > span.hidden').forEach(function(s){ if(s.textContent!==t) s.textContent=t; }); }
    renameBack(); // temaet opretter toggle-back-links EFTER custom.js — gentag når de dukker op
    // mobil: temaets/ældre scripts sætter inline background-color !important på ul.wide (drawer-bg) — fjern den, så kortene ligger direkte på panelet
    function clearWideBg(){ if(!window.matchMedia('(max-width:1000px)').matches) return; document.querySelectorAll('nav#nav ul.wide').forEach(function(w){ if(w.style.backgroundColor && w.style.backgroundColor!=='transparent') w.style.setProperty('background-color','transparent','important'); }); }
    clearWideBg();
    var navEl=document.querySelector('nav#nav'); if(navEl) new MutationObserver(function(){ renameBack(); clearWideBg(); }).observe(navEl,{childList:true,subtree:true,attributes:true,attributeFilter:['style']});
    window.addEventListener('resize', clearWideBg);
    document.querySelectorAll('nav#nav > ul > li').forEach(function(li){
      var a=li.querySelector(':scope > a:not(.toggle)'), w=li.querySelector(':scope > ul.wide');
      if(!a||!w||a.querySelector('.pb-tease')) return;
      var names=[].slice.call(w.querySelectorAll(':scope > li:not(.pb-nav-all) > ul > li > a:not(.toggle)')).map(function(x){return x.dataset.cc||x.textContent.trim();}).filter(Boolean);
      if(!names.length) return;
      var sp=document.createElement('span'); sp.className='pb-tease'; sp.textContent=names.join(' \u00b7 '); a.appendChild(sp);
    });
    // accordion: kun én gruppe åben ad gangen på niveau 2 (mobil)
    document.addEventListener('click', function(e){
      if(!window.matchMedia('(max-width:1000px)').matches) return;
      var t=e.target.closest('nav#nav ul.wide li.sub > a.toggle:not(.toggle-back)'); if(!t) return;
      var li=t.parentElement, wide=li.closest('ul.wide'); if(!wide) return;
      setTimeout(function(){
        if(!li.classList.contains('toggle')) return;
        wide.querySelectorAll('li.sub.toggle').forEach(function(o){ if(o!==li && !o.contains(li)) { o.classList.remove('toggle'); o.classList.remove('mtoggle'); } });
      }, 0);
    }, true);
    var nav=document.querySelector('nav#nav'); if(!nav) return;
    var sx=0, sy=0, tracking=false;
    nav.addEventListener('touchstart', function(e){ if(!window.matchMedia('(max-width:1000px)').matches) return; var t=e.touches[0]; sx=t.clientX; sy=t.clientY; tracking=true; e.stopPropagation(); }, {capture:true, passive:true});
    nav.addEventListener('touchmove', function(e){ e.stopPropagation(); }, {capture:true, passive:true});
    nav.addEventListener('touchend', function(e){
      e.stopPropagation(); if(!tracking) return; tracking=false;
      var t=e.changedTouches[0]; var dx=t.clientX-sx, dy=t.clientY-sy;
      if(dx < -60 && Math.abs(dy) < 50 && document.documentElement.classList.contains('m2a')){ var cl=nav.querySelector('a.close-nav'); if(cl) cl.click(); }
    }, {capture:true, passive:true});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', run); else run();
})();


/* ===== PB TRUSTPILOT-BAR 21-09-26: kompakt rating-linje i #nav-top. OPDATER TAL HER når scoren ændrer sig ===== */
(function(){
  var PB_TP={score:4.5, count:15, url:'https://www.trustpilot.com/review/pbcards.dk'};
  var W={da:['Fremragende','p\u00e5'],en:['Excellent','on'],de:['Hervorragend','auf'],sv:['Utm\u00e4rkt','p\u00e5'],nb:['Utmerket','p\u00e5'],no:['Utmerket','p\u00e5'],nl:['Uitstekend','op'],fi:['Erinomainen','\u00b7'],pl:['Doskona\u0142y','na'],it:['Eccellente','su'],fr:['Excellent','sur'],es:['Excelente','en']};
  function run(){
    var nt=document.querySelector('nav#nav-top'); if(!nt || nt.querySelector('.pb-tp')) return;
    var LC=(document.documentElement.lang||'en').slice(0,2); var t=W[LC]||W.en;
    var full=Math.floor(PB_TP.score), half=(PB_TP.score-full)>=0.25 && (PB_TP.score-full)<0.75, stars='';
    for(var i=1;i<=5;i++){ stars+= i<=full ? '<i></i>' : (i===full+1 && half ? '<i class="half"></i>' : (i===full+1 && (PB_TP.score-full)>=0.75 ? '<i></i>' : '<i class="empty"></i>')); }
    var a=document.createElement('a'); a.className='pb-tp'; a.href=PB_TP.url; a.target='_blank'; a.rel='noopener'; a.setAttribute('aria-label','Trustpilot '+PB_TP.score+'/5');
    a.innerHTML='<span class="pb-tp-word">'+t[0]+'</span><span class="pb-tp-stars">'+stars+'</span><span class="pb-tp-meta">'+String(PB_TP.score).replace('.',LC==='en'?'.':',')+' '+t[1]+'</span><span class="pb-tp-logo"><b></b>Trustpilot</span>';
    nt.insertBefore(a, nt.firstChild);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', run); else run();
})();


/* ===== PB FRI FRAGT-BAR 21-09-26: grænser pr. land (kun lande med fri fragt), matcher kundens land + valuta ===== */
(function(){
  var PB_FS={ DK:[800,'DKK'], SE:[3000,'SEK'], DE:[300,'EUR'], NL:[300,'EUR'], BE:[300,'EUR'], PL:[300,'EUR'], LU:[300,'EUR'], FR:[300,'EUR'] };
  var T={
    da:['Du mangler {x} for at f\u00e5 gratis fragt','Du har opn\u00e5et gratis fragt'],
    en:["You're {x} away from free shipping","You've unlocked free shipping"],
    de:['Noch {x} bis zum kostenlosen Versand','Kostenloser Versand freigeschaltet'],
    sv:['Du saknar {x} f\u00f6r fri frakt','Du har fri frakt'],
    nb:['Du mangler {x} for gratis frakt','Du har gratis frakt'], no:['Du mangler {x} for gratis frakt','Du har gratis frakt'],
    nl:['Nog {x} tot gratis verzending','Je hebt gratis verzending'],
    fi:['En\u00e4\u00e4 {x} ilmaiseen toimitukseen','Ilmainen toimitus'],
    pl:['Brakuje {x} do darmowej dostawy','Masz darmow\u0105 dostaw\u0119'],
    it:['Ti mancano {x} per la spedizione gratuita','Spedizione gratuita sbloccata'],
    fr:['Plus que {x} pour la livraison gratuite','Livraison gratuite obtenue'],
    es:['Te faltan {x} para el env\u00edo gratis','Tienes env\u00edo gratis']
  };
  var TRUCK='<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 7h13v9H1zM14 10h4l3 3v3h-7z"/><circle cx="5.5" cy="18" r="1.8" fill="#0e0f26"/><circle cx="17.5" cy="18" r="1.8" fill="#0e0f26"/></svg>';
  function rule(){ var S=window.Shopify||{}; var co=S.country, cur=S.currency&&S.currency.active; var r=PB_FS[co]; return (r && r[1]===cur) ? {limit:r[0], cur:cur} : null; }
  var timer=null, lastTotal=null;
  function render(totalCents){
    var cart=document.querySelector('aside#cart'); if(!cart) return;
    var r=rule(); var el=cart.querySelector('.pb-fs');
    if(!r){ if(el) el.remove(); return; }
    var LC=(document.documentElement.lang||'en').slice(0,2), t=T[LC]||T.en;
    var total=totalCents/100, miss=Math.max(0, r.limit-total), done=miss<=0;
    var loc={da:'da-DK',en:'en-GB',de:'de-DE',sv:'sv-SE',nb:'nb-NO',no:'nb-NO',nl:'nl-NL',fi:'fi-FI',pl:'pl-PL',it:'it-IT',fr:'fr-FR',es:'es-ES'}[LC]||'en-GB';
    var fmt; try{ fmt=new Intl.NumberFormat(loc,{style:'currency',currency:r.cur}).format(miss);}catch(e){ fmt=miss.toFixed(2)+' '+r.cur; }
    var txt= done ? t[1] : t[0].replace('{x}','<b>'+fmt+'</b>');
    var pct=Math.min(100, Math.round(total/r.limit*100));
    if(!el){ el=document.createElement('div'); el.className='pb-fs'; cart.insertBefore(el, cart.firstChild); }
    var html=TRUCK+'<span class="pb-fs-txt"><span>'+txt+'</span><span class="pb-fs-bar"><i style="width:'+pct+'%"></i></span></span>';
    if(el.getAttribute('data-h')!==html){ el.className='pb-fs'+(done?' done':''); el.innerHTML=html; el.setAttribute('data-h',html); }
    // mobil: læg baren præcis på X-knappens højde og skub temaets header (margin-top -45px) ned under den
    if(window.matchMedia('(max-width:1000px)').matches){ var x=[].slice.call(cart.querySelectorAll('a.m6pn-close')).filter(function(a){return getComputedStyle(a).position==='absolute';})[0]; var hd=cart.querySelector(':scope > header'); if(x&&hd){ var cr=cart.getBoundingClientRect(), xr=x.getBoundingClientRect(); var top=xr.top-cr.top; el.style.top=top+'px'; el.style.height=xr.height+'px'; var padTop=parseFloat(getComputedStyle(cart).paddingTop)||0; hd.style.marginTop=(top+xr.height+6-padTop)+'px'; } }
  }
  function quick(){
    // øjeblikkelig render fra det vi allerede ved (sidste /cart.js-svar eller temaets data-totalprice), så baren ikke "popper" sent
    var cart=document.querySelector('aside#cart'); if(!cart) return;
    // følg temaets egen tilstand (data-totalqty/data-totalprice på header), så baren aldrig er foran eller bagud i forhold til draweren
    var hd=cart.querySelector(':scope > header[data-totalprice]');
    if(!hd || !parseInt(hd.getAttribute('data-totalqty')||'0',10)){ var e=cart.querySelector('.pb-fs'); if(e) e.remove(); return; }
    var s=(hd.getAttribute('data-totalprice')||'').replace(/[^0-9.,]/g,''); if(!s) return;
    var dec=s.slice(-3).match(/[.,]/) ? s.slice(-3).match(/[.,]/)[0] : null; var num=dec ? s.replace(new RegExp('[^0-9'+dec+']','g'),'').replace(dec,'.') : s.replace(/[.,]/g,''); var v=parseFloat(num); if(!isNaN(v)) render(Math.round(v*100));
  }
  function refresh(){
    quick();
    clearTimeout(timer); timer=setTimeout(function(){
      fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){ lastTotal=c.total_price; var hd0=document.querySelector('aside#cart > header[data-totalprice]'); var themeQty=hd0?parseInt(hd0.getAttribute('data-totalqty')||'0',10):0; if(!c.item_count || !themeQty){ var e=document.querySelector('aside#cart .pb-fs'); if(e) e.remove(); return; } render(c.total_price); }).catch(function(){});
    }, 60);
  }
  function init(){
    if(!rule()) return;
    var cart=document.querySelector('aside#cart'); if(!cart) return;
    refresh();
    new MutationObserver(function(m){ var relevant=m.some(function(x){ if(x.target.closest && x.target.closest('.pb-fs')) return false; return [].slice.call(x.addedNodes).some(function(n){ return !(n.classList&&n.classList.contains('pb-fs')); }); }); if(relevant) refresh(); }).observe(cart,{childList:true,subtree:true});
    document.addEventListener('click', function(e){ if(e.target.closest('a[href="/cart"], .m6pn-close')) refresh(); }, true);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init); else init();
})();


/* ===== PB KURV SWIPE 21-09-26: swipe mod højre på kurv-draweren (aside#cart) lukker den på mobil/tablet — samme mønster som menuen (der swipes mod venstre) ===== */
(function(){
  function init(){
    var cart=document.querySelector('aside#cart'); if(!cart) return;
    var sx=0, sy=0, tracking=false;
    cart.addEventListener('touchstart', function(e){ if(!window.matchMedia('(max-width:1000px)').matches) return; var t=e.touches[0]; sx=t.clientX; sy=t.clientY; tracking=true; }, {passive:true});
    cart.addEventListener('touchend', function(e){
      if(!tracking) return; tracking=false;
      var t=e.changedTouches[0]; var dx=t.clientX-sx, dy=t.clientY-sy;
      if(dx > 60 && Math.abs(dy) < 50 && document.documentElement.classList.contains('m6pn-open')){
        var cl=[].slice.call(cart.querySelectorAll('a.m6pn-close')).filter(function(a){return getComputedStyle(a).position==='absolute';})[0] || cart.querySelector('a.m6pn-close');
        if(cl) cl.click();
      }
    }, {passive:true});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init); else init();
})();



// September Slutspurt – gør avisen fuldbredde og centreret uanset sidekolonne
(function(){
  function fit(){
    var a=document.querySelector('.avis');if(!a)return;
    a.style.marginLeft='0px';a.style.width='';
    var r=a.getBoundingClientRect();
    a.style.width=document.documentElement.clientWidth+'px';
    a.style.marginLeft=(-r.left)+'px';
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fit);else fit();
  window.addEventListener('load',fit);window.addEventListener('resize',fit);
})();

/* ===== PB FILTER-ACCORDION 26-09-26 (desktop) — hver filtergruppe i form#filter bliver et sammenklappeligt kort.
   Lukket som standard; åben hvis gruppen har et aktivt valg; husker åben/lukket pr. gruppe i sessionStorage.
   Kun ≥1001px (mobil-draweren bruger temaets egen accordion). Tåler AJAX-genrendering af filteret. ===== */
(function(){
  var MQ = window.matchMedia('(min-width:1001px)');
  var SKIP = 'p.link-btn.submit';

  function priceChanged(g){
    var mn = g.querySelector('#min'), mx = g.querySelector('#max');
    return !!((mn && mn.value !== '' && +mn.value > +(mn.getAttribute('min') || 0)) ||
              (mx && mx.value !== '' && +mx.value < +(mx.getAttribute('max') || Infinity)));
  }
  function activeCount(g){
    return g.querySelectorAll('input[type=checkbox]:checked').length + (priceChanged(g) ? 1 : 0);
  }
  function setOpen(g, open, remember){
    g.classList.toggle('open', !!open);
    if (remember) { try { sessionStorage.setItem('pbfg:' + g.dataset.key, open ? '1' : '0'); } catch(e){} }
  }
  function onHead(e){
    if (!MQ.matches) return;                 // mobil: lad temaet håndtere h4
    e.preventDefault(); e.stopPropagation();
    var g = this.closest('.pb-fg'); setOpen(g, !g.classList.contains('open'), true);
  }

  function build(){
    if (!MQ.matches) return;
    var fs = document.querySelector('form#filter fieldset');
    if (!fs || fs.dataset.pbAcc) return;
    fs.dataset.pbAcc = '1';
    var kids = Array.prototype.slice.call(fs.children), cur = null;
    kids.forEach(function(el){
      if (el.tagName === 'H4') {
        cur = null;
        if (!el.hasAttribute('data-filter-toggle') || el.classList.contains('desktop-hide')) return; // fx "Tilgængelighed" (skjult overskrift på desktop) forbliver som den er
        var g = document.createElement('div'); g.className = 'pb-fg'; g.dataset.key = el.getAttribute('data-filter-toggle');
        fs.insertBefore(g, el); g.appendChild(el);
        var body = document.createElement('div'); body.className = 'pb-fg-body';
        var inner = document.createElement('div'); body.appendChild(inner); g.appendChild(body);
        var cnt = document.createElement('span'); cnt.className = 'pb-fg-count';
        var chev = document.createElement('span'); chev.className = 'pb-fg-chev';
        el.appendChild(cnt); el.appendChild(chev);
        el.addEventListener('click', onHead);
        cur = inner;
      } else if (cur && !el.matches(SKIP)) {
        cur.appendChild(el);
      } else {
        cur = null;
      }
    });
    refresh(fs);
    fs.querySelectorAll('.pb-fg').forEach(function(g){
      var st = null; try { st = sessionStorage.getItem('pbfg:' + g.dataset.key); } catch(e){}
      setOpen(g, activeCount(g) > 0 || st === '1', false);
    });
  }

  function refresh(fs){
    fs = fs || document.querySelector('form#filter fieldset'); if (!fs) return;
    fs.querySelectorAll('.pb-fg').forEach(function(g){
      var n = activeCount(g), c = g.querySelector(':scope > h4 .pb-fg-count');
      if (c) c.textContent = n ? String(n) : '';
      if (n && !g.classList.contains('open')) setOpen(g, true, false);
    });
  }

  function unbuild(){
    var fs = document.querySelector('form#filter fieldset');
    if (!fs || !fs.dataset.pbAcc) return;
    fs.querySelectorAll('.pb-fg').forEach(function(g){
      var h = g.querySelector(':scope > h4');
      h.querySelectorAll('.pb-fg-count,.pb-fg-chev').forEach(function(x){ x.remove(); });
      h.removeEventListener('click', onHead);
      fs.insertBefore(h, g);
      var inner = g.querySelector('.pb-fg-body > div');
      while (inner.firstChild) fs.insertBefore(inner.firstChild, g);
      g.remove();
    });
    delete fs.dataset.pbAcc;
  }

  var t;
  function schedule(){ clearTimeout(t); t = setTimeout(function(){ MQ.matches ? build() : unbuild(); }, 60); }

  MQ.addEventListener ? MQ.addEventListener('change', schedule) : MQ.addListener(schedule);
  document.addEventListener('change', function(e){ if (e.target.closest && e.target.closest('form#filter')) refresh(); }, true);
  new MutationObserver(function(muts){
    for (var i = 0; i < muts.length; i++) {
      var tg = muts[i].target;
      if (tg.closest && tg.closest('.pb-fg-body')) continue;  // egne/indre ændringer (Vis mere etc.) ignoreres
      if (tg.matches && (tg.matches('form#filter, form#filter fieldset') || tg.querySelector && tg.querySelector('form#filter'))) { schedule(); return; }
    }
  }).observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
})();

/* PB: ankerlinks i guides (indholdsfortegnelse) - bloed animation, lander lige under topbar/sticky header, og retter efter hvis billeder undervejs aendrer layoutet */
(function(){
  if(!document.body || !document.body.classList.contains('template-article')) return;
  function covered(){
    var items=[];
    document.querySelectorAll('.shopify-section-group-header-group, .shopify-section-group-header-group *').forEach(function(el){
      var c=getComputedStyle(el);
      if(c.display==='none' || c.visibility==='hidden') return;
      var r=el.getBoundingClientRect();
      if(r.height<=0 || r.width<window.innerWidth*0.5) return;
      if(c.position==='fixed'){ if(r.bottom>0 && r.top<window.innerHeight*0.4) items.push([r.top, r.bottom]); }
      else if(c.position==='sticky'){ var tp=parseFloat(c.top); if(!isNaN(tp)) items.push([tp, tp+r.height]); }
    });
    items.sort(function(a,b){ return a[0]-b[0]; });
    var cov=0;
    items.forEach(function(it){ if(it[0]<=cov+2) cov=Math.max(cov, it[1]); });
    return cov;
  }
  function go(id, push){
    var t=document.getElementById(id); if(!t) return false;
    var dest=function(){ return Math.max(0, t.getBoundingClientRect().top + window.pageYOffset - covered() - 16); };
    window.scrollTo({top: dest(), behavior: 'smooth'});
    var done=false;
    var fix=function(){ if(done) return; done=true; var d=dest(); if(Math.abs(d - window.pageYOffset) > 4) window.scrollTo({top: d, behavior: 'smooth'}); };
    if('onscrollend' in window){ window.addEventListener('scrollend', fix, {once: true}); setTimeout(fix, 1600); }
    else { setTimeout(fix, 900); }
    if(push) history.pushState(null, '', '#'+id);
    return true;
  }
  document.addEventListener('click', function(e){
    var a=e.target.closest && e.target.closest('a[href^="#"]'); if(!a) return;
    var id=decodeURIComponent(a.getAttribute('href').slice(1)); if(!id) return;
    if(go(id, true)) e.preventDefault();
  });
  window.addEventListener('load', function(){
    if(location.hash.length>1) setTimeout(function(){ go(decodeURIComponent(location.hash.slice(1)), false); }, 150);
  });
})();



/* ===== PB DROPS 29-09-26 ===== v2: lyn-knap i headeren + panel m. kategori-chips (Alle / spil / Singles / Kommer snart) — data fra sections/pb-drops.liquid via ?section_id=pb-drops */
(function(){
  if (window.__pbDrops) return; window.__pbDrops = 1;
  var LC = (document.documentElement.lang || 'en').slice(0,2).toLowerCase(); if (LC === 'no' || LC === 'nn') LC = 'nb';
  var TX = {
    da:['Nyheder','Alle','Kommer snart','Se alle nyheder','Ingen nyheder lige nu','Udkommer','Luk','Singles','Gradede Kort'],
    en:['New releases','All','Coming soon','See all new releases','Nothing new right now','Releases','Close','Singles','Graded cards'],
    de:['Neuheiten','Alle','Demnächst','Alle Neuheiten ansehen','Gerade keine Neuheiten','Erscheint','Schließen','Einzelkarten','Gegradete Karten'],
    sv:['Nyheter','Alla','Kommer snart','Se alla nyheter','Inga nyheter just nu','Släpps','Stäng','Singles','Graderade kort'],
    nb:['Nyheter','Alle','Kommer snart','Se alle nyheter','Ingen nyheter akkurat nå','Slippes','Lukk','Singles','Graderte kort'],
    nl:['Nieuw','Alle','Binnenkort','Bekijk alle nieuwe releases','Nu niets nieuws','Verschijnt','Sluiten','Losse kaarten','Gegradeerde kaarten'],
    fi:['Uutuudet','Kaikki','Tulossa','Katso kaikki uutuudet','Ei uutuuksia juuri nyt','Julkaisu','Sulje','Yksittäiskortit','Gradeeratut kortit'],
    pl:['Nowości','Wszystko','Wkrótce','Zobacz wszystkie nowości','Brak nowości','Premiera','Zamknij','Pojedyncze karty','Karty gradowane'],
    it:['Novità','Tutte','In arrivo','Vedi tutte le novità','Nessuna novità al momento','Uscita','Chiudi','Carte singole','Carte gradate'],
    fr:['Nouveautés','Tout','Bientôt','Voir toutes les nouveautés','Rien de nouveau pour le moment','Sortie','Fermer','Cartes à l’unité','Cartes gradées'],
    es:['Novedades','Todo','Próximamente','Ver todas las novedades','Nada nuevo ahora mismo','Lanzamiento','Cerrar','Cartas sueltas','Cartas gradeadas']
  };
  var T = TX[LC] || TX.en;
  var ROOT = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/');
  var BASE = ROOT.replace(/\/$/, '');
  var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
  var KEY = 'pbDrops4:' + LC + ':' + CUR, SEEN = 'pbDropsSeen';
  var PER = 12;
  var BOLT = '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" stroke-linecap="round" aria-hidden="true"><path d="M13 2 4 14h7l-1 8 9-12h-7l1-8z"/></svg>';
  var li, btn, panel, ov, body, tabsEl, data = null, loading = false, tab = 'all';

  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function ls(k, v){ try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch(e){ return null; } }
  function short(v){
    var s = (v || '').toLowerCase();
    if (/pok[eé]mon/.test(s)) return 'Pokémon';
    if (/one piece/.test(s)) return 'One Piece';
    if (/lorcana/.test(s)) return 'Lorcana';
    if (/riftbound/.test(s)) return 'Riftbound';
    if (/magic/.test(s)) return 'Magic';
    if (/dragon ball/.test(s)) return 'Dragon Ball';
    if (/yu-?gi-?oh/.test(s)) return 'Yu-Gi-Oh!';
    if (/palworld/.test(s)) return 'Palworld';
    if (/digimon/.test(s)) return 'Digimon';
    return v || '';
  }

  function mountBtn(){
    var ul = document.querySelector('nav#nav-user > ul');
    if (!ul || ul.querySelector('.pb-drops-li')) return !!ul;
    li = document.createElement('li'); li.className = 'pb-drops-li';
    li.innerHTML = '<a href="' + BASE + '/collections/new-releases" class="pb-drops-btn" role="button" aria-haspopup="dialog" aria-expanded="false" aria-label="' + esc(T[0]) + '" title="' + esc(T[0]) + '">' + BOLT + '<span class="pb-drops-dot" aria-hidden="true"></span></a>';
    ul.insertBefore(li, ul.querySelector(':scope > li.cart'));
    btn = li.querySelector('a');
    btn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); toggle(); });
    return true;
  }

  function mountPanel(){
    ov = document.createElement('div'); ov.className = 'pb-dr-ov'; document.body.appendChild(ov);
    panel = document.createElement('div'); panel.id = 'pb-drops'; panel.setAttribute('role','dialog'); panel.setAttribute('aria-label', T[0]); panel.setAttribute('aria-hidden','true');
    panel.innerHTML = '<div class="pb-dr-head"><span class="pb-dr-grab" aria-hidden="true"></span><span class="pb-dr-title">' + BOLT + esc(T[0]) + '</span><span class="pb-dr-x" role="button" tabindex="0" aria-label="' + esc(T[6]) + '">&times;</span></div>'
      + '<div class="pb-dr-tabs" role="tablist"></div>'
      + '<div class="pb-dr-body"><div class="pb-dr-load"><i></i><i></i><i></i></div></div>'
      + '<a class="pb-dr-all" href="' + BASE + '/collections/new-releases">' + esc(T[3]) + ' <span aria-hidden="true">&rarr;</span></a>';
    document.body.appendChild(panel);
    body = panel.querySelector('.pb-dr-body'); tabsEl = panel.querySelector('.pb-dr-tabs');
    ov.addEventListener('click', close);
    var x = panel.querySelector('.pb-dr-x');
    x.addEventListener('click', close);
    x.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); close(); } });
    var suppress = false, drag = null;
    tabsEl.addEventListener('click', function(e){ if (suppress) { e.preventDefault(); e.stopPropagation(); return; } var t = e.target.closest('[data-tab]'); if (t) setTab(t.getAttribute('data-tab'), t); }, true);
    tabsEl.addEventListener('keydown', function(e){ var t = e.target.closest('[data-tab]'); if (t && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); setTab(t.getAttribute('data-tab'), t); } });
    tabsEl.addEventListener('wheel', function(e){ if (Math.abs(e.deltaY) > Math.abs(e.deltaX) && tabsEl.scrollWidth > tabsEl.clientWidth) { tabsEl.scrollLeft += e.deltaY; e.preventDefault(); } }, { passive: false });
    tabsEl.addEventListener('pointerdown', function(e){ if (e.pointerType === 'mouse' && e.button !== 0) return; drag = { x: e.clientX, y: e.clientY, sl: tabsEl.scrollLeft, id: e.pointerId, moved: false }; });
    tabsEl.addEventListener('pointermove', function(e){ if (!drag || e.pointerId !== drag.id) return; var dx = e.clientX - drag.x, dy = e.clientY - drag.y; if (!drag.moved) { if (Math.abs(dx) < 6 || Math.abs(dx) < Math.abs(dy)) return; drag.moved = true; try { tabsEl.setPointerCapture(e.pointerId); } catch(_){} tabsEl.classList.add('pb-drag'); } tabsEl.scrollLeft = drag.sl - dx; e.preventDefault(); });
    function dragEnd(e){ if (!drag || (e && e.pointerId !== drag.id)) return; if (drag.moved) { tabsEl.classList.remove('pb-drag'); suppress = true; setTimeout(function(){ suppress = false; }, 50); } drag = null; }
    tabsEl.addEventListener('pointerup', dragEnd); tabsEl.addEventListener('pointercancel', dragEnd); tabsEl.addEventListener('lostpointercapture', dragEnd);
    tabsEl.addEventListener('dragstart', function(e){ e.preventDefault(); });
    document.addEventListener('click', function(e){ if (isOpen() && !panel.contains(e.target) && !(li && li.contains(e.target))) close(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && isOpen()) close(); });
    window.addEventListener('resize', place, { passive: true });
    window.addEventListener('scroll', function(){ if (isOpen()) place(); }, { passive: true });
    /* mobil bottom-sheet: træk ned i toppen (håndtaget) med finger eller mus for at lukke — arket følger med og glider tilbage hvis man slipper tidligt */
    var sd = null, hd = panel.querySelector('.pb-dr-head');
    hd.addEventListener('pointerdown', function(e){
      if (window.innerWidth > 1000 || !isOpen() || e.target.closest('.pb-dr-x')) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      sd = { y: e.clientY, t: Date.now(), id: e.pointerId, dy: 0, s: [{ y: e.clientY, t: performance.now() }] };
      try { hd.setPointerCapture(e.pointerId); } catch(_){}
      panel.classList.add('pb-dr-dragging');
    });
    hd.addEventListener('pointermove', function(e){
      if (!sd || e.pointerId !== sd.id) return;
      var dy = e.clientY - sd.y; sd.dy = dy > 0 ? dy : dy / 6; var now = performance.now(); sd.s.push({ y: e.clientY, t: now }); while (sd.s.length > 2 && now - sd.s[0].t > 120) sd.s.shift();
      panel.style.transform = 'translateY(' + Math.round(sd.dy) + 'px)';
      ov.style.opacity = String(Math.max(0.15, 1 - Math.max(0, sd.dy) / 420));
      e.preventDefault();
    });
    function sheetEnd(e){
      if (!sd || (e && e.pointerId !== sd.id)) return;
      var dy = sd.dy, sa = sd.s[0], sb = sd.s[sd.s.length - 1], v = (sb.y - sa.y) / Math.max(1, sb.t - sa.t);
      sd = null; panel.classList.remove('pb-dr-dragging'); ov.style.opacity = '';
      if (dy > 90 || (dy > 16 && v > 0.35)) { close(); setTimeout(function(){ panel.style.transform = ''; }, 240); }
      else panel.style.transform = '';
    }
    hd.addEventListener('pointerup', sheetEnd); hd.addEventListener('pointercancel', sheetEnd); hd.addEventListener('lostpointercapture', sheetEnd);
  }

  function nice(a){
    var t = a.querySelector('.pb-dr-t'); if (!t || t.getAttribute('data-n')) return; t.setAttribute('data-n', 1);
    var p = t.textContent.split(' - ');
    if (p.length >= 3 && a.getAttribute('data-s') === '2') t.innerHTML = '<small>' + esc(p[0]) + ' · ' + esc(p[2]) + '</small>' + esc([p[1]].concat(p.slice(3)).join(' – '));
    else if (p.length >= 3) t.innerHTML = '<small>' + esc(p[0]) + ' · ' + esc(p[1]) + '</small>' + esc(p.slice(2).join(' – '));
    else if (p.length === 2) t.innerHTML = '<small>' + esc(p[0]) + '</small>' + esc(p[1]);
  }

  function parse(h){
    var d = new DOMParser().parseFromString(h, 'text/html').querySelector('#pb-drops-data');
    if (!d) return null;
    var items = [].slice.call(d.querySelectorAll('[data-list="new"] > .pb-dr-item'));
    var soon = [].slice.call(d.querySelectorAll('[data-list="soon"] > .pb-dr-item'));
    soon.sort(function(a, b){ return (a.getAttribute('data-date') || '9999') < (b.getAttribute('data-date') || '9999') ? -1 : 1; });
    soon.forEach(function(a){
      var ds = a.getAttribute('data-date'), m = ds && ds.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (m) { try { a.querySelector('.pb-dr-date').textContent = T[5] + ' ' + new Intl.DateTimeFormat(document.documentElement.lang || 'en', { day: 'numeric', month: 'short', year: 'numeric' }).format(new Date(+m[1], +m[2] - 1, +m[3])); } catch(e){} }
    });
    var groups = [], map = {}, sealed = [], singles = [], graded = [];
    items.forEach(function(a){
      var s = a.getAttribute('data-s'); if (s === '2') { graded.push(a); return; } if (s) { singles.push(a); return; }
      sealed.push(a);
      var g = short(a.getAttribute('data-v'));
      if (!map[g]) { map[g] = { key: 'g:' + g, label: g, items: [] }; groups.push(map[g]); }
      map[g].items.push(a);
    });
    var every = items.slice().sort(function(a, b){ return (+b.getAttribute('data-t') || 0) - (+a.getAttribute('data-t') || 0); });
    var tabs = [{ key: 'all', label: T[1], items: every.slice(0, PER) }];
    if (groups.length > 1) groups.forEach(function(g){ tabs.push({ key: g.key, label: g.label, items: g.items.slice(0, PER) }); });
    if (singles.length) tabs.push({ key: 'singles', label: T[7], items: singles.slice(0, PER) });
    if (graded.length) tabs.push({ key: 'graded', label: T[8], items: graded.slice(0, PER) });
    if (soon.length) tabs.push({ key: 'soon', label: T[2], items: soon, soon: true });
    return { newest: +d.getAttribute('data-newest') || 0, tabs: tabs, nNew: sealed.length };
  }

  function load(cb){
    if (data) { cb && cb(); return; }
    if (loading) return; loading = true;
    var c = null; try { c = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch(e){}
    if (c && Date.now() - c.t < 600000) { data = parse(c.h); loading = false; after(); cb && cb(); return; }
    fetch(ROOT + '?section_id=pb-drops', { credentials: 'same-origin' }).then(function(r){ return r.text(); }).then(function(h){
      try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), h: h })); } catch(e){}
      data = parse(h); loading = false; after(); cb && cb();
    }).catch(function(){ loading = false; });
  }

  function after(){
    if (!data) return;
    if (li) li.classList.toggle('has-new', data.nNew > 0 && data.newest > (+ls(SEEN) || 0));
    if (tabsEl) {
      tabsEl.innerHTML = data.tabs.map(function(t){ return '<span role="tab" tabindex="0" data-tab="' + esc(t.key) + '"' + (t.soon ? ' class="soon"' : '') + '>' + esc(t.label) + (t.key !== 'all' ? '<em>' + t.items.length + '</em>' : '') + '</span>'; }).join('');
      if (!data.tabs.some(function(t){ return t.key === tab && t.items.length; })) { var f = data.tabs.filter(function(t){ return t.items.length; })[0]; tab = f ? f.key : 'all'; }
    }
    if (isOpen()) render();
  }

  function render(){
    if (!data) return;
    var cur = data.tabs.filter(function(t){ return t.key === tab; })[0] || data.tabs[0];
    body.innerHTML = '';
    var l = document.createElement('div'); l.className = 'pb-dr-list on';
    if (cur && cur.items.length) cur.items.forEach(function(a){ var c = a.cloneNode(true); nice(c); l.appendChild(c); });
    else l.innerHTML = '<p class="pb-dr-empty">' + esc(T[4]) + '</p>';
    body.appendChild(l);
    [].forEach.call(tabsEl.querySelectorAll('[data-tab]'), function(t){ var on = t.getAttribute('data-tab') === (cur && cur.key); t.classList.toggle('on', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
  }

  function centerChip(el){ if (!el || !tabsEl) return; var max = tabsEl.scrollWidth - tabsEl.clientWidth; if (max <= 0) return; var to = Math.max(0, Math.min(max, el.offsetLeft - (tabsEl.clientWidth - el.offsetWidth) / 2)); var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches; if (reduce || !window.requestAnimationFrame) { tabsEl.scrollLeft = to; return; } var from = tabsEl.scrollLeft, d = to - from, t0 = null, dur = 420; if (Math.abs(d) < 2) return; if (tabsEl.__pbAnim) cancelAnimationFrame(tabsEl.__pbAnim); function step(ts){ if (t0 === null) t0 = ts; var p = Math.min(1, (ts - t0) / dur), e = p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2; tabsEl.scrollLeft = from + d * e; if (p < 1) tabsEl.__pbAnim = requestAnimationFrame(step); else tabsEl.__pbAnim = 0; } tabsEl.__pbAnim = requestAnimationFrame(step); }
  function setTab(k, el){ tab = k; render(); body.scrollTop = 0; centerChip(el); }
  function isOpen(){ return panel && panel.classList.contains('open'); }

  function place(){
    if (!panel || !btn) return;
    if (window.innerWidth > 1000) {
      var r = btn.getBoundingClientRect();
      panel.style.top = Math.round(r.bottom + 12) + 'px';
      panel.style.right = Math.max(12, Math.round(window.innerWidth - r.right - 14)) + 'px';
    } else { panel.style.top = ''; panel.style.right = ''; }
  }

  function open(){
    place();
    panel.classList.add('open'); ov.classList.add('open'); panel.setAttribute('aria-hidden','false'); btn.setAttribute('aria-expanded','true');
    document.documentElement.classList.add('pb-dr-on');
    load(function(){ render(); if (data) { ls(SEEN, String(data.newest)); li.classList.remove('has-new'); } });
  }
  function close(){
    if (!panel) return;
    panel.classList.remove('open'); ov.classList.remove('open'); panel.setAttribute('aria-hidden','true'); if (btn) btn.setAttribute('aria-expanded','false');
    document.documentElement.classList.remove('pb-dr-on');
  }
  function toggle(){ isOpen() ? close() : open(); }

  /* mobil: når #nav-user fylder hele headeren (logo centreret) flyttes lynet op ved siden af burgeren, så ikonerne ikke klemmer logoet */
  function fitMobile(){
    if (!li) return;
    var nu = document.querySelector('#nav-user'), bg = document.querySelector('#header-inner > p.link-btn');
    if (!nu || !bg) return;
    var a = nu.getBoundingClientRect(), b = bg.getBoundingClientRect();
    var left = b.width > 0 && Math.abs(a.left - b.left) < 6 && a.width > window.innerWidth * 0.6;
    li.classList.toggle('pb-dr-left', left);
    if (left) { var op = li.offsetParent || nu, o = op.getBoundingClientRect(); li.style.left = Math.round(b.right - o.left + 10) + 'px'; } else li.style.left = '';
  }
  function init(){
    if (!mountBtn()) return;
    mountPanel();
    fitMobile(); setTimeout(fitMobile, 400); setTimeout(fitMobile, 1500);
    window.addEventListener('resize', fitMobile, { passive: true });
    if (window.ResizeObserver) { var hi = document.querySelector('#header-inner'); if (hi) new ResizeObserver(fitMobile).observe(hi); }
    setTimeout(function(){ load(); }, 1500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();


/* ===== PB NAV DRAG 29-09-26 ===== v4 — mobil burger-menu: håndtag øverst + træk (op/ned) i top-rækken for at lukke.
   KUN passive lyttere (delegeret på nav#nav) — menulisten bliver aldrig blokeret/træg. Browseren kan ikke overtage trækket fordi
   top-rækken + håndtaget har touch-action:none (CSS-blok PB NAV DRAG). Hastighed over sidste ~100 ms. */
(function(){
  var nav, sd = null, suppress = false, ZONE = '.pb-nav-grab, div.header:not(.header-before), ul.nav-top, a.close-nav';
  function mob(){ return window.innerWidth <= 1000; }
  function isOpen(){ return document.documentElement.classList.contains('m2a'); }
  function inZone(t, y){ var z = t && t.closest && t.closest(ZONE); if (z && nav.contains(z)) return true; return t === nav && y !== undefined && y - nav.getBoundingClientRect().top < 72; }
  function reset(){ if (!nav) return; nav.style.removeProperty('transform'); nav.style.removeProperty('opacity'); }
  function begin(y, kind, id){ sd = { y: y, kind: kind, id: id, dy: 0, moved: false, s: [{ y: y, t: performance.now() }] }; }
  function move(y){
    if (!sd) return false;
    var dy = y - sd.y;
    if (!sd.moved) { if (Math.abs(dy) < 6) return false; sd.moved = true; nav.classList.add('pb-nav-dragging'); }
    sd.dy = dy;
    var now = performance.now(); sd.s.push({ y: y, t: now }); while (sd.s.length > 2 && now - sd.s[0].t > 120) sd.s.shift();
    nav.style.setProperty('transform', 'translateY(' + Math.round(dy) + 'px)', 'important');
    nav.style.setProperty('opacity', String(Math.max(0.35, 1 - Math.abs(dy) / 380)), 'important');
    return true;
  }
  function finish(){
    if (!sd) return; var s = sd; sd = null;
    if (!s.moved) return;
    nav.classList.remove('pb-nav-dragging');
    var a = s.s[0], b = s.s[s.s.length - 1], v = (b.y - a.y) / Math.max(1, b.t - a.t);
    var fling = Math.abs(v) > 0.35 && Math.abs(s.dy) > 16 && (v > 0) === (s.dy > 0);
    if (Math.abs(s.dy) > 80 || fling) {
      nav.style.removeProperty('opacity');
      var x = nav.querySelector('a.close-nav');
      if (x) x.click(); else document.documentElement.classList.remove('m2a');
      setTimeout(reset, 280);
    } else reset();
    suppress = true; setTimeout(function(){ suppress = false; }, 80);
  }
  function setup(){
    nav = document.querySelector('nav#nav');
    if (!nav || nav.__pbDrag) return; nav.__pbDrag = 1;
    if (!nav.querySelector(':scope > .pb-nav-grab')) { var g = document.createElement('span'); g.className = 'pb-nav-grab'; g.setAttribute('aria-hidden', 'true'); nav.insertBefore(g, nav.firstChild); }
    var P = { passive: true, capture: true }; /* capture: temaets egne swipe-lyttere på nav#nav stopper propagation i capture-fasen */
    nav.addEventListener('touchstart', function(e){ if (e.touches.length !== 1 || !mob() || !isOpen() || !inZone(e.target, e.touches[0].clientY)) { sd = null; return; } begin(e.touches[0].clientY, 'touch', e.touches[0].identifier); }, P);
    nav.addEventListener('touchmove', function(e){ if (!sd || sd.kind !== 'touch') return; for (var i = 0; i < e.touches.length; i++) if (e.touches[i].identifier === sd.id) { move(e.touches[i].clientY); break; } }, P);
    nav.addEventListener('touchend', function(){ if (sd && sd.kind === 'touch') finish(); }, P);
    nav.addEventListener('touchcancel', function(){ if (sd && sd.kind === 'touch') finish(); }, P);
    nav.addEventListener('pointerdown', function(e){ if (e.pointerType !== 'mouse' || e.button !== 0 || !mob() || !isOpen() || !inZone(e.target, e.clientY)) return; begin(e.clientY, 'mouse', e.pointerId); try { nav.setPointerCapture(e.pointerId); } catch(_){} });
    nav.addEventListener('pointermove', function(e){ if (sd && sd.kind === 'mouse' && e.pointerId === sd.id) move(e.clientY); });
    nav.addEventListener('pointerup', function(e){ if (sd && sd.kind === 'mouse' && e.pointerId === sd.id) finish(); });
    nav.addEventListener('pointercancel', function(e){ if (sd && sd.kind === 'mouse' && e.pointerId === sd.id) finish(); });
    nav.addEventListener('click', function(e){ if (suppress) { e.preventDefault(); e.stopPropagation(); } }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
})();
